/**
 * List of location names and slugs for display on the Deals page
 */
export const USLocations = [
  {
    locations: [
      { name: "Anchorage", slug: "anchorage-ak-us" },
      { name: "Fairbanks", slug: "fairbanks-ak-us" },
      { name: "Haines", slug: "haines-ak-us" },
      { name: "Healy", slug: "healy-ak-us" },
      { name: "Homer", slug: "homer-ak-us" },
      { name: "Juneau", slug: "juneau-ak-us" },
      { name: "Kenai", slug: "kenai-ak-us" },
      { name: "Ketchikan", slug: "ketchikan-ak-us" },
      { name: "North Pole", slug: "north-pole-ak-us" },
      { name: "Palmer", slug: "palmer-ak-us" },
      { name: "Petersburg", slug: "petersburg-ak-us" },
      { name: "Sitka", slug: "sitka-ak-us" },
      { name: "Skagway", slug: "skagway-ak-us" },
      { name: "Soldotna", slug: "soldotna-ak-us" },
      { name: "Sterling", slug: "sterling-ak-us" },
      { name: "Talkeetna", slug: "talkeetna-ak-us" },
      { name: "Valdez", slug: "valdez-ak-us" },
      { name: "Wasilla", slug: "wasilla-ak-us" },
      { name: "Wrangell", slug: "wrangell-ak-us" },
    ],
    name: "Alaska",
  },
  {
    locations: [
      { name: "Brookland", slug: "brookland-ar-us" },
      { name: "Hot Springs", slug: "hot-springs-ar-us" },
      { name: "Jonesboro", slug: "jonesboro-ar-us" },
    ],
    name: "Arkansas",
  },
  {
    locations: [
      { name: "Apache Junction", slug: "apache-junction-az-us" },
      { name: "Avondale", slug: "avondale-az-us" },
      { name: "Benson", slug: "benson-az-us" },
      { name: "Bisbee", slug: "bisbee-az-us" },
      { name: "Buckeye", slug: "buckeye-az-us" },
      { name: "Casa Grande", slug: "casa-grande-az-us" },
      { name: "Cave Creek", slug: "cave-creek-az-us" },
      { name: "Chandler", slug: "chandler-az-us" },
      { name: "Chino Valley", slug: "chino-valley-az-us" },
      { name: "Cochise", slug: "cochise-az-us" },
      { name: "Coolidge", slug: "cottonwood-az-us" },
      { name: "El Mirage", slug: "el-mirage-az-us" },
      { name: "Flagstaff", slug: "flagstaff-az-us" },
      { name: "Fountain Hills", slug: "fountain-hills-az-us" },
      { name: "Gilbert", slug: "gilbert-az-us" },
      { name: "Glendale", slug: "glendale-az-us" },
      { name: "Globe", slug: "globe-az-us" },
      { name: "Goodyear", slug: "goodyear-az-us" },
      { name: "Green Valley", slug: "green-valley-az-us" },
      { name: "Guadalupe", slug: "guadalupe-az-us" },
      { name: "Kingman", slug: "kingman-az-us" },
      { name: "Lake Havasu City", slug: "lake-havasu-city-az-us" },
      { name: "Mesa", slug: "mesa-az-us" },
      { name: "Mohave Valley", slug: "mohave-valley-az-us" },
      { name: "New River", slug: "new-river-az-us" },
      { name: "Payson", slug: "payson-az-us" },
      { name: "Peoria", slug: "peoria-az-us" },
      { name: "Phoenix", slug: "phoenix-az-us" },
      { name: "Prescott", slug: "prescott-az-us" },
      { name: "Prescott Valley", slug: "prescott-valley-az-us" },
      { name: "Queen Creek", slug: "queen-creek-az-us" },
      { name: "Safford", slug: "safford-az-us" },
      { name: "Scottsdale", slug: "scottsdale-az-us" },
      { name: "Sedona", slug: "sedona-az-us" },
      { name: "Show Low", slug: "show-low-az-us" },
      { name: "Sierra Vista", slug: "sierra-vista-az-us" },
      { name: "Snowflake", slug: "snowflake-az-us" },
      { name: "Sun City", slug: "sun-city-az-us" },
      { name: "Tempe", slug: "tempe-az-us" },
      { name: "Tolleson", slug: "tolleson-az-us" },
      { name: "Tucson", slug: "tucson-az-us" },
      { name: "Wickenburg", slug: "wickenburg-az-us" },
      { name: "Winslow", slug: "winslow-az-us" },
      { name: "Youngtown", slug: "youngtown-az-us" },
      { name: "Yuma", slug: "yuma-az-us" },
    ],
    name: "Arizona",
  },
  {
    locations: [
      { name: "Acton", slug: "acton-ca-us" },
      { name: "Adelanto", slug: "adelanto-ca-us" },
      { name: "Alameda", slug: "alameda-ca-us" },
      { name: "Aliso Viejo", slug: "aliso-viejo-ca-us" },
      { name: "Anaheim", slug: "anaheim-ca-us" },
      { name: "Antelope", slug: "antelope-ca-us" },
      { name: "Antioch", slug: "antioch-ca-us" },
      { name: "Aptos", slug: "aptos-ca-us" },
      { name: "Arcadia", slug: "arcadia-ca-us" },
      { name: "Arcata", slug: "arcata-ca-us" },
      { name: "Arnold", slug: "arnold-ca-us" },
      { name: "Atwater", slug: "atwater-ca-us" },
      { name: "Bakersfield", slug: "bakersfield-ca-us" },
      { name: "Barstow", slug: "barstow-ca-us" },
      { name: "Beckwourth", slug: "beckwourth-ca-us" },
      { name: "Bell Gardens", slug: "bell-gardens-ca-us" },
      { name: "Bellflower", slug: "bellflower-ca-us" },
      { name: "Ben Lomond", slug: "ben-lomond-ca-us" },
      { name: "Berkeley", slug: "berkeley-ca-us" },
      { name: "Beverly Hills", slug: "beverly-hills-ca-us" },
      { name: "Big Bear", slug: "big-bear-ca-us" },
      { name: "Blackhawk", slug: "blackhawk-ca-us" },
      { name: "Blythe", slug: "blythe-ca-us" },
      { name: "Boulder Creek", slug: "boulder-creek-ca-us" },
      { name: "Brawley", slug: "brawley-ca-us" },
      { name: "Brisbane", slug: "brisbane-ca-us" },
      { name: "Burbank", slug: "burbank-ca-us" },
      { name: "Burlingame", slug: "burlingame-ca-us" },
      { name: "Cameron Park", slug: "cameron-park-ca-us" },
      { name: "Canyon Lake", slug: "canyon-lake-ca-us" },
      { name: "Carlsbad", slug: "carlsbad-ca-us" },
      { name: "Carmel By The Sea", slug: "carmel-by-the-sea-ca-us" },
      { name: "Castroville", slug: "castroville-ca-us" },
      { name: "Cathedral City", slug: "cathedral-city-ca-us" },
      { name: "Ceres", slug: "ceres-ca-us" },
      { name: "Chico", slug: "chico-ca-us" },
      { name: "Chino Hills", slug: "chino-hills-ca-us" },
      { name: "Chula Vista", slug: "chula-vista-ca-us" },
      { name: "Citrus Heights", slug: "citrus-heights-ca-us" },
      { name: "Clearlake", slug: "clearlake-ca-us" },
      { name: "Coachella", slug: "coachella-ca-us" },
      { name: "Coalinga", slug: "coalinga-ca-us" },
      { name: "Colfax", slug: "colfax-ca-us" },
      { name: "Colma", slug: "colma-ca-us" },
      { name: "Colusa", slug: "colusa-ca-us" },
      { name: "Concord", slug: "concord-ca-us" },
      { name: "Copperopolis", slug: "copperopolis-ca-us" },
      { name: "Corona", slug: "corona-ca-us" },
      { name: "Cotati", slug: "cotati-ca-us" },
      { name: "Covina", slug: "covina-ca-us" },
      { name: "Crescent City", slug: "crescent-city-ca-us" },
      { name: "Crows Landing", slug: "crows-landing-ca-us" },
      { name: "Culver City", slug: "culver-city-ca-us" },
      { name: "Cypress", slug: "cypress-ca-us" },
      { name: "Daly City", slug: "daly-city-ca-us" },
      { name: "Dana Point", slug: "dana-point-ca-us" },
      { name: "Danville", slug: "danville-ca-us" },
      { name: "Davis", slug: "davis-ca-us" },
      { name: "Del Mar", slug: "del-mar-ca-us" },
      { name: "Del Rey Oaks", slug: "del-rey-oaks-ca-us" },
      { name: "Denair", slug: "denair-ca-us" },
      { name: "Desert Hot Springs", slug: "desert-hot-springs-ca-us" },
      { name: "Diamond Springs", slug: "diamond-springs-ca-us" },
      { name: "Dixon", slug: "dixon-ca-us" },
      { name: "Dublin", slug: "dublin-ca-us" },
      { name: "El Cajon", slug: "el-cajon-ca-us" },
      { name: "El Segundo", slug: "el-segundo-ca-us" },
      { name: "El Sobrante", slug: "el-sobrante-ca-us" },
      { name: "Elk Grove", slug: "elk-grove-ca-us" },
      { name: "Emeryville", slug: "emeryville-ca-us" },
      { name: "Encinitas", slug: "encinitas-ca-us" },
      { name: "Escondido", slug: "escondido-ca-us" },
      { name: "Eureka", slug: "eureka-ca-us" },
      { name: "Fairfax", slug: "fairfax-ca-us" },
      { name: "Fairfield", slug: "fairfield-ca-us" },
      { name: "Fallbrook", slug: "fallbrook-ca-us" },
      { name: "Felton", slug: "felton-ca-us" },
      { name: "Folsom", slug: "folsom-ca-us" },
      { name: "Fontana", slug: "fontana-ca-us" },
      { name: "Fort Bragg", slug: "fort-bragg-ca-us" },
      { name: "Fountain Valley", slug: "fountain-valley-ca-us" },
      { name: "Fremont", slug: "fremont-ca-us" },
      { name: "Fresno", slug: "fresno-ca-us" },
      { name: "Garberville", slug: "garberville-ca-us" },
      { name: "Gardena", slug: "gardena-ca-us" },
      { name: "Glendale", slug: "glendale-ca-us" },
      { name: "Glendora", slug: "glendora-ca-us" },
      { name: "Goleta", slug: "goleta-ca-us" },
      { name: "Groveland", slug: "groveland-ca-us" },
      { name: "Grover Beach", slug: "grover-beach-ca-us" },
      { name: "Gualala", slug: "gualala-ca-us" },
      { name: "Guerneville", slug: "guerneville-ca-us" },
      { name: "Half Moon Bay", slug: "half-moon-bay-ca-us" },
      { name: "Hayfork", slug: "hayfork-ca-us" },
      { name: "Hayward", slug: "hayward-ca-us" },
      { name: "Hemet", slug: "hemet-ca-us" },
      { name: "Hermosa Beach", slug: "hermosa-beach-ca-us" },
      { name: "Hesperia", slug: "hesperia-ca-us" },
      { name: "Hopland", slug: "hopland-ca-us" },
      { name: "Huntington Beach", slug: "huntington-beach-ca-us" },
      { name: "Indio", slug: "indio-ca-us" },
      { name: "Irvine", slug: "irvine-ca-us" },
      { name: "June Lake", slug: "june-lake-ca-us" },
      { name: "La Mesa", slug: "la-mesa-ca-us" },
      { name: "La Verne", slug: "la-verne-ca-us" },
      { name: "Ladera Ranch", slug: "ladera-ranch-ca-us" },
      { name: "Laguna Beach", slug: "laguna-beach-ca-us" },
      { name: "Laguna Niguel", slug: "laguna-niguel-ca-us" },
      { name: "Lake Elsinore", slug: "lake-elsinore-ca-us" },
      { name: "Lakewood", slug: "lakewood-ca-us" },
      { name: "Lancaster", slug: "lancaster-ca-us" },
      { name: "Larkfield-Wikiup", slug: "larkfield-wikiup-ca-us" },
      { name: "Laytonville", slug: "laytonville-ca-us" },
      { name: "Littlerock", slug: "littlerock-ca-us" },
      { name: "Lomita", slug: "lomita-ca-us" },
      { name: "Lompoc", slug: "lompoc-ca-us" },
      { name: "Long Beach", slug: "long-beach-ca-us" },
      { name: "Loomis", slug: "loomis-ca-us" },
      { name: "Los Angeles", slug: "los-angeles-ca-us" },
      { name: "Los Gatos", slug: "los-gatos-ca-us" },
      { name: "Lucerne", slug: "lucerne-ca-us" },
      { name: "Lynwood", slug: "lynwood-ca-us" },
      { name: "Malibu", slug: "malibu-ca-us" },
      { name: "Mammoth Lakes", slug: "mammoth-lakes-ca-us" },
      { name: "Manhattan Beach", slug: "manhattan-beach-ca-us" },
      { name: "Marina Del Rey", slug: "marina-del-rey-ca-us" },
      { name: "Marysville", slug: "marysville-ca-us" },
      { name: "Maywood", slug: "maywood-ca-us" },
      { name: "Mckinleyville", slug: "mckinleyville-ca-us" },
      { name: "Mendocino", slug: "mendocino-ca-us" },
      { name: "Menlo Park", slug: "menlo-park-ca-us" },
      { name: "Merced", slug: "merced-ca-us" },
      { name: "Millbrae", slug: "millbrae-ca-us" },
      { name: "Milpitas", slug: "milpitas-ca-us" },
      { name: "Mission Viejo", slug: "mission-viejo-ca-us" },
      { name: "Modesto", slug: "modesto-ca-us" },
      { name: "Monterey", slug: "monterey-ca-us" },
      { name: "Moreno Valley", slug: "moreno-valley-ca-us" },
      { name: "Morro Bay", slug: "morro-bay-ca-us" },
      { name: "Mount Shasta", slug: "mount-shasta-ca-us" },
      { name: "Mountain View", slug: "mountain-view-ca-us" },
      { name: "Murrieta", slug: "murrieta-ca-us" },
      { name: "Napa", slug: "napa-ca-us" },
      { name: "National City", slug: "national-city-ca-us" },
      { name: "Needles", slug: "needles-ca-us" },
      { name: "Nevada City", slug: "nevada-city-ca-us" },
      { name: "Newcastle", slug: "newcastle-ca-us" },
      { name: "Newport Beach", slug: "newport-beach-ca-us" },
      { name: "Nicolaus", slug: "nicolaus-ca-us" },
      { name: "Oakland", slug: "oakland-ca-us" },
      { name: "Oceano", slug: "oceano-ca-us" },
      { name: "Oceanside", slug: "oceanside-ca-us" },
      { name: "Ojai", slug: "ojai-ca-us" },
      { name: "Ontario", slug: "ontario-ca-us" },
      { name: "Pacifica", slug: "pacifica-ca-us" },
      { name: "Pajaro", slug: "pajaro-ca-us" },
      { name: "Palm Desert", slug: "palm-desert-ca-us" },
      { name: "Palm Springs", slug: "palm-springs-ca-us" },
      { name: "Palmdale", slug: "palmdale-ca-us" },
      { name: "Palo Alto", slug: "palo-alto-ca-us" },
      { name: "Pasadena", slug: "pasadena-ca-us" },
      { name: "Paso Robles", slug: "paso-robles-ca-us" },
      { name: "Patterson", slug: "patterson-ca-us" },
      { name: "Perris", slug: "perris-ca-us" },
      { name: "Petaluma", slug: "petaluma-ca-us" },
      { name: "Piedmont", slug: "piedmont-ca-us" },
      { name: "Pismo Beach", slug: "pismo-beach-ca-us" },
      { name: "Pleasant Hill", slug: "pleasant-hill-ca-us" },
      { name: "Pleasanton", slug: "pleasanton-ca-us" },
      { name: "Point Arena", slug: "point-arena-ca-us" },
      { name: "Port Hueneme", slug: "port-hueneme-ca-us" },
      { name: "Ramona", slug: "ramona-ca-us" },
      { name: "Rancho Cucamonga", slug: "rancho-cucamonga-ca-us" },
      { name: "Redding", slug: "redding-ca-us" },
      { name: "Redlands", slug: "redlands-ca-us" },
      { name: "Redondo Beach", slug: "redondo-beach-ca-us" },
      { name: "Redwood City", slug: "redwood-city-ca-us" },
      { name: "Richmond", slug: "richmond-ca-us" },
      { name: "Rio Vista", slug: "rio-vista-ca-us" },
      { name: "Riverbank", slug: "riverbank-ca-us" },
      { name: "Riverside", slug: "riverside-ca-us" },
      { name: "Rocklin", slug: "rocklin-ca-us" },
      { name: "Rosemead", slug: "rosemead-ca-us" },
      { name: "Roseville", slug: "roseville-ca-us" },
      { name: "Sacramento", slug: "sacramento-ca-us" },
      { name: "Salinas", slug: "salinas-ca-us" },
      { name: "San Andreas", slug: "san-andreas-ca-us" },
      { name: "San Bernardino", slug: "san-bernardino-ca-us" },
      { name: "San Bruno", slug: "san-bruno-ca-us" },
      { name: "San Carlos", slug: "san-carlos-ca-us" },
      { name: "San Clemente", slug: "san-clemente-ca-us" },
      { name: "San Diego", slug: "san-diego-ca-us" },
      { name: "San Francisco", slug: "san-francisco-ca-us" },
      { name: "San Jose", slug: "san-jose-ca-us" },
      { name: "San Leandro", slug: "san-leandro-ca-us" },
      { name: "San Lorenzo", slug: "san-lorenzo-ca-us" },
      { name: "San Luis Obispo", slug: "san-luis-obispo-ca-us" },
      { name: "San Mateo", slug: "san-mateo-ca-us" },
      { name: "San Rafael", slug: "san-rafael-ca-us" },
      { name: "San Ramon", slug: "san-ramon-ca-us" },
      { name: "Sanger", slug: "sanger-ca-us" },
      { name: "Santa Ana", slug: "santa-ana-ca-us" },
      { name: "Santa Barbara", slug: "santa-barbara-ca-us" },
      { name: "Santa Clara", slug: "santa-clara-ca-us" },
      { name: "Santa Clarita", slug: "santa-clarita-ca-us" },
      { name: "Santa Cruz", slug: "santa-cruz-ca-us" },
      { name: "Santa Maria", slug: "santa-maria-ca-us" },
      { name: "Santa Monica", slug: "santa-monica-ca-us" },
      { name: "Santa Rosa", slug: "santa-rosa-ca-us" },
      { name: "Santee", slug: "santee-ca-us" },
      { name: "Sausalito", slug: "sausalito-ca-us" },
      { name: "Seaside", slug: "seaside-ca-us" },
      { name: "Sebastopol", slug: "sebastopol-ca-us" },
      { name: "Shasta Lake", slug: "shasta-lake-ca-us" },
      { name: "Shingle Springs", slug: "shingle-springs-ca-us" },
      { name: "Solvang", slug: "solvang-ca-us" },
      { name: "Sonora", slug: "sonora-ca-us" },
      { name: "Soquel", slug: "soquel-ca-us" },
      { name: "South Lake Tahoe", slug: "south-lake-tahoe-ca-us" },
      { name: "South San Francisco", slug: "south-san-francisco-ca-us" },
      { name: "Stanford", slug: "stanford-ca-us" },
      { name: "Stockton", slug: "stockton-ca-us" },
      { name: "Susanville", slug: "susanville-ca-us" },
      { name: "Temecula", slug: "temecula-ca-us" },
      { name: "Thousand Oaks", slug: "thousand-oaks-ca-us" },
      { name: "Torrance", slug: "torrance-ca-us" },
      { name: "Tulare", slug: "tulare-ca-us" },
      { name: "Twain Harte", slug: "twain-harte-ca-us" },
      { name: "Ukiah", slug: "ukiah-ca-us" },
      { name: "Union City", slug: "union-city-ca-us" },
      { name: "Vacaville", slug: "vacaville-ca-us" },
      { name: "Vallejo", slug: "vallejo-ca-us" },
      { name: "Ventura", slug: "ventura-ca-us" },
      { name: "Victorville", slug: "victorville-ca-us" },
      { name: "Visalia", slug: "visalia-ca-us" },
      { name: "Vista", slug: "vista-ca-us" },
      { name: "Walnut Creek", slug: "walnut-creek-ca-us" },
      { name: "Weed", slug: "weed-ca-us" },
      { name: "West Covina", slug: "west-covina-ca-us" },
      { name: "West Hollywood", slug: "west-hollywood-ca-us" },
      { name: "West Sacramento", slug: "west-sacramento-ca-us" },
      { name: "Whittier", slug: "whittier-ca-us" },
      { name: "Winchester", slug: "winchester-ca-us" },
      { name: "Woodlake", slug: "woodlake-ca-us" },
      { name: "Woodside", slug: "woodside-ca-us" },
      { name: "Wrightwood", slug: "wrightwood-ca-us" },
      { name: "Yuba City", slug: "yuba-city-ca-us" },
    ],
    name: "California",
  },
  {
    locations: [
      { name: "Alamosa", slug: "alamosa-co-us" },
      { name: "Alma", slug: "alma-co-us" },
      { name: "Antonito", slug: "antonito-co-us" },
      { name: "Aspen", slug: "aspen-co-us" },
      { name: "Aurora", slug: "aurora-co-us" },
      { name: "Avon", slug: "avon-co-us" },
      { name: "Bailey", slug: "bailey-co-us" },
      { name: "Basalt", slug: "basalt-co-us" },
      { name: "Berthoud", slug: "berthoud-co-us" },
      { name: "Black Hawk", slug: "black-hawk-co-us" },
      { name: "Blanca", slug: "blanca-co-us" },
      { name: "Boulder", slug: "boulder-co-us" },
      { name: "Breckenridge", slug: "breckenridge-co-us" },
      { name: "Cañon City", slug: "ca%C3%B1on-city-co-us" },
      { name: "Carbondale", slug: "carbondale-co-us" },
      {
        name: "Cascade-Chipita Park",
        slug: "cascade-chipita-park-co-us",
      },
      { name: "Central City", slug: "central-city-co-us" },
      { name: "Colorado Springs", slug: "colorado-springs-co-us" },
      { name: "Commerce City", slug: "commerce-city-co-us" },
      { name: "Cortez", slug: "cortez-co-us" },
      { name: "Crested Butte", slug: "crested-butte-co-us" },
      { name: "De Beque", slug: "de-beque-co-us" },
      { name: "Denver", slug: "denver-co-us" },
      { name: "Dinosaur", slug: "dinosaur-co-us" },
      { name: "Divide", slug: "divide-co-us" },
      {
        name: "Downieville-Lawson-Dumont",
        slug: "downieville-lawson-dumont-co-us",
      },
      { name: "Durango", slug: "durango-co-us" },
      { name: "Eagle", slug: "eagle-co-us" },
      { name: "Edgewater", slug: "edgewater-co-us" },
      { name: "Edwards", slug: "edwards-co-us" },
      { name: "Empire", slug: "empire-co-us" },
      { name: "Englewood", slug: "englewood-co-us" },
      { name: "Estes Park", slug: "estes-park-co-us" },
      { name: "Fairplay", slug: "fairplay-co-us" },
      { name: "Federal Heights", slug: "federal-heights-co-us" },
      { name: "Fort Collins", slug: "fort-collins-co-us" },
      { name: "Fort Morgan", slug: "fort-morgan-co-us" },
      { name: "Fraser", slug: "fraser-co-us" },
      { name: "Frisco", slug: "frisco-co-us" },
      { name: "Garden City", slug: "garden-city-co-us" },
      { name: "Georgetown", slug: "georgetown-co-us" },
      { name: "Glenwood Springs", slug: "glenwood-springs-co-us" },
      { name: "Golden", slug: "golden-co-us" },
      { name: "Gunnison", slug: "gunnison-co-us" },
      { name: "Idaho Springs", slug: "idaho-springs-co-us" },
      { name: "Lafayette", slug: "lafayette-co-us" },
      { name: "Lakewood", slug: "lakewood-co-us" },
      { name: "Leadville", slug: "leadville-co-us" },
      { name: "Littleton", slug: "littleton-co-us" },
      { name: "Longmont", slug: "longmont-co-us" },
      { name: "Louisville", slug: "louisville-co-us" },
      { name: "Lyons", slug: "lyons-co-us" },
      { name: "Mancos", slug: "mancos-co-us" },
      { name: "Manitou Springs", slug: "manitou-springs-co-us" },
      { name: "Moffat", slug: "moffat-co-us" },
      { name: "Montrose", slug: "montrose-co-us" },
      { name: "Nederland", slug: "nederland-co-us" },
      { name: "Niwot", slug: "niwot-co-us" },
      { name: "Northglenn", slug: "northglenn-co-us" },
      { name: "Oak Creek", slug: "oak-creek-co-us" },
      { name: "Pagosa Springs", slug: "pagosa-springs-co-us" },
      { name: "Palisade", slug: "palisade-co-us" },
      { name: "Palmer Lake", slug: "palmer-lake-co-us" },
      { name: "Parachute", slug: "parachute-co-us" },
      { name: "Penrose", slug: "penrose-co-us" },
      { name: "Pueblo", slug: "pueblo-co-us" },
      { name: "Pueblo West", slug: "pueblo-west-co-us" },
      { name: "Ridgway", slug: "ridgway-co-us" },
      { name: "Rifle", slug: "rifle-co-us" },
      { name: "Salida", slug: "salida-co-us" },
      { name: "San Luis", slug: "san-luis-co-us" },
      { name: "Sedgwick", slug: "sedgwick-co-us" },
      { name: "Silt", slug: "silt-co-us" },
      { name: "Silver Plume", slug: "silver-plume-co-us" },
      { name: "Silverthorne", slug: "silverthorne-co-us" },
      { name: "Silverton", slug: "silverton-co-us" },
      { name: "Steamboat Springs", slug: "steamboat-springs-co-us" },
      { name: "Tabernash", slug: "tabernash-co-us" },
      { name: "Telluride", slug: "telluride-co-us" },
      { name: "Thornton", slug: "thornton-co-us" },
      { name: "Trinidad", slug: "trinidad-co-us" },
      { name: "Vail", slug: "vail-co-us" },
      { name: "Villa Grove", slug: "villa-grove-co-us" },
      { name: "Walsenburg", slug: "walsenburg-co-us" },
      { name: "Wheat Ridge", slug: "wheat-ridge-co-us" },
    ],
    name: "Colorado",
  },
  {
    locations: [
      { name: "Bethel", slug: "bethel-ct-us" },
      { name: "Branford", slug: "branford-ct-us" },
      { name: "Bristol", slug: "bristol-ct-us" },
      { name: "Hartford", slug: "hartford-ct-us" },
      { name: "Mansfield", slug: "mansfield-ct-us" },
      { name: "Milford", slug: "milford-ct-us" },
      { name: "Montville", slug: "montville-ct-us" },
      { name: "South Windsor", slug: "south-windsor-ct-us" },
      { name: "Stamford", slug: "stamford-ct-us" },
      { name: "Waterbury", slug: "waterbury-ct-us" },
      { name: "Windham", slug: "windham-ct-us" },
    ],
    name: "Connecticut",
  },
  {
    locations: [{ name: "Washington", slug: "washington-dc-us" }],
    name: "District of Columbia",
  },
  {
    locations: [
      { name: "Lewes", slug: "lewes-de-us" },
      { name: "Smyrna", slug: "smyrna-de-us" },
      { name: "Wilmington", slug: "wilmington-de-us" },
    ],
    name: "Delaware",
  },
  {
    locations: [
      { name: "Apollo Beach", slug: "apollo-beach-fl-us" },
      { name: "Bonita Springs", slug: "bonita-springs-fl-us" },
      { name: "Boynton Beach", slug: "boynton-beach-fl-us" },
      { name: "Bradenton", slug: "bradenton-fl-us" },
      { name: "Brandon", slug: "brandon-fl-us" },
      { name: "Clearwater", slug: "clearwater-fl-us" },
      { name: "Coral Gables", slug: "coral-gables-fl-us" },
      { name: "Dania Beach", slug: "dania-beach-fl-us" },
      { name: "Daytona Beach", slug: "daytona-beach-fl-us" },
      { name: "Deerfield Beach", slug: "deerfield-beach-fl-us" },
      { name: "Deltona", slug: "deltona-fl-us" },
      { name: "Edgewater", slug: "edgewater-fl-us" },
      { name: "Fort Lauderdale", slug: "fort-lauderdale-fl-us" },
      { name: "Fort Myers", slug: "fort-myers-fl-us" },
      { name: "Fort Pierce", slug: "fort-pierce-fl-us" },
      { name: "Fort Walton Beach", slug: "fort-walton-beach-fl-us" },
      { name: "Gainesville", slug: "gainesville-fl-us" },
      { name: "Holly Hill", slug: "holly-hill-fl-us" },
      { name: "Jacksonville", slug: "jacksonville-fl-us" },
      { name: "Kendall", slug: "kendall-fl-us" },
      { name: "Kissimmee", slug: "kissimmee-fl-us" },
      { name: "Lady Lake", slug: "lady-lake-fl-us" },
      { name: "Lake Worth", slug: "lake-worth-fl-us" },
      { name: "Lakeland", slug: "lakeland-fl-us" },
      { name: "Largo", slug: "largo-fl-us" },
      { name: "Longwood", slug: "longwood-fl-us" },
      { name: "Lutz", slug: "lutz-fl-us" },
      { name: "Melbourne", slug: "melbourne-fl-us" },
      { name: "Merritt Island", slug: "merritt-island-fl-us" },
      { name: "Miami", slug: "miami-fl-us" },
      { name: "Miami Beach", slug: "miami-beach-fl-us" },
      { name: "Miami Gardens", slug: "miami-gardens-fl-us" },
      { name: "New Port Richey", slug: "new-port-richey-fl-us" },
      { name: "North Fort Myers", slug: "north-fort-myers-fl-us" },
      { name: "North Palm Beach", slug: "north-palm-beach-fl-us" },
      { name: "North Port", slug: "north-port-fl-us" },
      { name: "Ocala", slug: "ocala-fl-us" },
      { name: "Orange Park", slug: "orange-park-fl-us" },
      { name: "Orlando", slug: "orlando-fl-us" },
      { name: "Palm Bay", slug: "palm-bay-fl-us" },
      { name: "Palm Coast", slug: "palm-coast-fl-us" },
      { name: "Palm Harbor", slug: "palm-harbor-fl-us" },
      { name: "Palmetto", slug: "palmetto-fl-us" },
      { name: "Pensacola", slug: "pensacola-fl-us" },
      { name: "Port Orange", slug: "port-orange-fl-us" },
      { name: "Port St. Lucie", slug: "port-st-lucie-fl-us" },
      { name: "Saint Petersburg", slug: "saint-petersburg-fl-us" },
      { name: "Sarasota", slug: "sarasota-fl-us" },
      { name: "St. Augustine", slug: "st-augustine-fl-us" },
      { name: "Summerfield", slug: "summerfield-fl-us" },
      { name: "Tallahassee", slug: "tallahassee-fl-us" },
      { name: "Tampa", slug: "tampa-fl-us" },
      { name: "Titusville", slug: "titusville-fl-us" },
      { name: "Venice", slug: "venice-fl-us" },
      { name: "Vero Beach", slug: "vero-beach-fl-us" },
      { name: "Wellington", slug: "wellington-fl-us" },
      { name: "West Palm Beach", slug: "west-palm-beach-fl-us" },
      { name: "Winter Haven", slug: "winter-haven-fl-us" },
    ],
    name: "Florida",
  },
  {
    locations: [
      { name: "Honolulu", slug: "honolulu-hi-us" },
      { name: "Kahului", slug: "kahului-hi-us" },
      { name: "Kaneohe", slug: "kaneohe-hi-us" },
      { name: "Kapaa", slug: "kapaa-hi-us" },
      { name: "Waimea", slug: "waimea-hi-us" },
    ],
    name: "Hawaii",
  },
  {
    locations: [
      { name: "Council Bluffs", slug: "council-bluffs-ia-us" },
      { name: "Davenport", slug: "davenport-ia-us" },
    ],
    name: "Iowa",
  },
  {
    locations: [
      { name: "Addison", slug: "addison-il-us" },
      { name: "Anna", slug: "anna-il-us" },
      { name: "Arlington Heights", slug: "arlington-heights-il-us" },
      { name: "Buffalo Grove", slug: "buffalo-grove-il-us" },
      { name: "Canton", slug: "canton-il-us" },
      { name: "Champaign", slug: "champaign-il-us" },
      { name: "Chicago", slug: "chicago-il-us" },
      { name: "Collinsville", slug: "collinsville-il-us" },
      { name: "Effingham", slug: "effingham-il-us" },
      { name: "Elmwood Park", slug: "elmwood-park-il-us" },
      { name: "Evanston", slug: "evanston-il-us" },
      { name: "Fulton", slug: "fulton-il-us" },
      { name: "Grandview", slug: "grandview-il-us" },
      { name: "Harrisburg", slug: "harrisburg-il-us" },
      { name: "Highland Park", slug: "highland-park-il-us" },
      { name: "Homewood", slug: "homewood-il-us" },
      { name: "Joliet", slug: "joliet-il-us" },
      { name: "Justice", slug: "justice-il-us" },
      { name: "Litchfield", slug: "litchfield-il-us" },
      { name: "Marion", slug: "marion-il-us" },
      { name: "Milan", slug: "milan-il-us" },
      { name: "Mokena", slug: "mokena-il-us" },
      { name: "Morris", slug: "morris-il-us" },
      { name: "Mount Prospect", slug: "mount-prospect-il-us" },
      { name: "Mundelein", slug: "mundelein-il-us" },
      { name: "Naperville", slug: "naperville-il-us" },
      { name: "Normal", slug: "normal-il-us" },
      { name: "North Aurora", slug: "north-aurora-il-us" },
      { name: "Northbrook", slug: "northbrook-il-us" },
      { name: "Oak Park", slug: "oak-park-il-us" },
      { name: "Ottawa", slug: "ottawa-il-us" },
      { name: "Peoria", slug: "peoria-il-us" },
      { name: "Posen", slug: "posen-il-us" },
      { name: "Quincy", slug: "quincy-il-us" },
      { name: "Rockford", slug: "rockford-il-us" },
      { name: "Rolling Meadows", slug: "rolling-meadows-il-us" },
      { name: "Romeoville", slug: "romeoville-il-us" },
      { name: "Sauget", slug: "sauget-il-us" },
      { name: "Springfield", slug: "springfield-il-us" },
      { name: "St. Charles", slug: "st-charles-il-us" },
      { name: "Worth", slug: "worth-il-us" },
    ],
    name: "Illinois",
  },
  {
    locations: [{ name: "Griffith", slug: "griffith-in-us" }],
    name: "Indiana",
  },
  {
    locations: [{ name: "Independence", slug: "independence-ks-us" }],
    name: "Kansas",
  },
  {
    locations: [{ name: "New Orleans", slug: "new-orleans-la-us" }],
    name: "Louisiana",
  },
  {
    locations: [
      { name: "Acton", slug: "acton-ma-us" },
      { name: "Amesbury", slug: "amesbury-ma-us" },
      { name: "Amherst", slug: "amherst-ma-us" },
      { name: "Arlington", slug: "arlington-ma-us" },
      { name: "Athol", slug: "athol-ma-us" },
      { name: "Attleboro", slug: "attleboro-ma-us" },
      { name: "Ayer", slug: "ayer-ma-us" },
      { name: "Boston", slug: "boston-ma-us" },
      { name: "Bridgewater", slug: "bridgewater-ma-us" },
      { name: "Brockton", slug: "brockton-ma-us" },
      { name: "Brookline", slug: "brookline-ma-us" },
      { name: "Cambridge", slug: "cambridge-ma-us" },
      { name: "Chicopee", slug: "chicopee-ma-us" },
      { name: "Dennis", slug: "dennis-ma-us" },
      { name: "Easthampton", slug: "easthampton-ma-us" },
      { name: "Fairhaven", slug: "fairhaven-ma-us" },
      { name: "Fall River", slug: "fall-river-ma-us" },
      { name: "Framingham", slug: "framingham-ma-us" },
      { name: "Gardner", slug: "gardner-ma-us" },
      { name: "Georgetown", slug: "georgetown-ma-us" },
      { name: "Great Barrington", slug: "great-barrington-ma-us" },
      { name: "Greenfield", slug: "greenfield-ma-us" },
      { name: "Hanover", slug: "hanover-ma-us" },
      { name: "Hudson", slug: "hudson-ma-us" },
      { name: "Leicester", slug: "leicester-ma-us" },
      { name: "Lenox", slug: "lenox-ma-us" },
      { name: "Leominster", slug: "leominster-ma-us" },
      { name: "Lowell", slug: "lowell-ma-us" },
      { name: "Lynn", slug: "lynn-ma-us" },
      { name: "Malden", slug: "malden-ma-us" },
      { name: "Mansfield", slug: "mansfield-ma-us" },
      { name: "Marlborough", slug: "marlborough-ma-us" },
      { name: "Mashpee", slug: "mashpee-ma-us" },
      { name: "Milford", slug: "milford-ma-us" },
      { name: "Millis", slug: "millis-ma-us" },
      { name: "Needham", slug: "needham-ma-us" },
      { name: "Newton", slug: "newton-ma-us" },
      { name: "Northampton", slug: "northampton-ma-us" },
      { name: "Orange", slug: "orange-ma-us" },
      { name: "Oxford", slug: "oxford-ma-us" },
      { name: "Pittsfield", slug: "pittsfield-ma-us" },
      { name: "Plymouth", slug: "plymouth-ma-us" },
      { name: "Provincetown", slug: "provincetown-ma-us" },
      { name: "Quincy", slug: "quincy-ma-us" },
      { name: "Salem", slug: "salem-ma-us" },
      { name: "Shrewsbury", slug: "shrewsbury-ma-us" },
      { name: "Somerset", slug: "somerset-ma-us" },
      { name: "Somerville", slug: "somerville-ma-us" },
      { name: "Springfield", slug: "springfield-ma-us" },
      { name: "Taunton", slug: "taunton-ma-us" },
      { name: "Uxbridge", slug: "uxbridge-ma-us" },
      { name: "Wareham", slug: "wareham-ma-us" },
      { name: "Westborough", slug: "westborough-ma-us" },
      { name: "Williamstown", slug: "williamstown-ma-us" },
      { name: "Worcester", slug: "worcester-ma-us" },
    ],
    name: "Massachusetts",
  },
  {
    locations: [
      { name: "Aberdeen", slug: "aberdeen-md-us" },
      { name: "Abingdon", slug: "abingdon-md-us" },
      { name: "Annapolis", slug: "annapolis-md-us" },
      { name: "Baltimore", slug: "baltimore-md-us" },
      { name: "Bethesda", slug: "bethesda-md-us" },
      { name: "Bowie", slug: "bowie-md-us" },
      { name: "Brandywine", slug: "brandywine-md-us" },
      { name: "Burtonsville", slug: "burtonsville-md-us" },
      { name: "Cambridge", slug: "cambridge-md-us" },
      { name: "Camp Springs", slug: "camp-springs-md-us" },
      { name: "Capitol Heights", slug: "capitol-heights-md-us" },
      { name: "Catonsville", slug: "catonsville-md-us" },
      { name: "Centreville", slug: "centreville-md-us" },
      { name: "Cockeysville", slug: "cockeysville-md-us" },
      { name: "Columbia", slug: "columbia-md-us" },
      { name: "Crofton", slug: "crofton-md-us" },
      { name: "Cumberland", slug: "cumberland-md-us" },
      { name: "Edgewater", slug: "edgewater-md-us" },
      { name: "Elkton", slug: "elkton-md-us" },
      { name: "Ellicott City", slug: "ellicott-city-md-us" },
      { name: "Gaithersburg", slug: "gaithersburg-md-us" },
      { name: "Germantown", slug: "germantown-md-us" },
      { name: "Halethorpe", slug: "halethorpe-md-us" },
      { name: "Jessup", slug: "jessup-md-us" },
      {
        name: "Lutherville-Timonium",
        slug: "lutherville-timonium-md-us",
      },
      { name: "Mechanicsville", slug: "mechanicsville-md-us" },
      { name: "Middle River", slug: "middle-river-md-us" },
      { name: "New Market", slug: "new-market-md-us" },
      { name: "North Bethesda", slug: "north-bethesda-md-us" },
      { name: "Nottingham", slug: "nottingham-md-us" },
      { name: "Ocean City", slug: "ocean-city-md-us" },
      { name: "Olney", slug: "olney-md-us" },
      { name: "Perryville", slug: "perryville-md-us" },
      { name: "Pikesville", slug: "pikesville-md-us" },
      { name: "Queenstown", slug: "queenstown-md-us" },
      { name: "Reisterstown", slug: "reisterstown-md-us" },
      { name: "Rockville", slug: "rockville-md-us" },
      { name: "Salisbury", slug: "salisbury-md-us" },
      { name: "Silver Spring", slug: "silver-spring-md-us" },
      { name: "Solomons", slug: "solomons-md-us" },
      { name: "Street", slug: "street-md-us" },
      { name: "Takoma Park", slug: "takoma-park-md-us" },
      { name: "Upper Marlboro", slug: "upper-marlboro-md-us" },
      { name: "Waldorf", slug: "waldorf-md-us" },
      { name: "Westminster", slug: "westminster-md-us" },
      { name: "White Plains", slug: "white-plains-md-us" },
    ],
    name: "Maryland",
  },
  {
    locations: [
      { name: "Auburn", slug: "auburn-me-us" },
      { name: "Augusta", slug: "augusta-me-us" },
      { name: "Bangor", slug: "bangor-me-us" },
      { name: "Bath", slug: "bath-me-us" },
      { name: "Belfast", slug: "belfast-me-us" },
      { name: "Berwick", slug: "berwick-me-us" },
      { name: "Biddeford", slug: "biddeford-me-us" },
      { name: "Boothbay", slug: "boothbay-me-us" },
      { name: "Bowdoinham", slug: "bowdoinham-me-us" },
      { name: "Brewer", slug: "brewer-me-us" },
      { name: "Brunswick", slug: "brunswick-me-us" },
      { name: "Caribou", slug: "caribou-me-us" },
      { name: "Cornish", slug: "cornish-me-us" },
      { name: "Damariscotta", slug: "damariscotta-me-us" },
      { name: "Edgecomb", slug: "edgecomb-me-us" },
      { name: "Eliot", slug: "eliot-me-us" },
      { name: "Ellsworth", slug: "ellsworth-me-us" },
      { name: "Fairfield", slug: "fairfield-me-us" },
      { name: "Farmington", slug: "farmington-me-us" },
      { name: "Fort Kent", slug: "fort-kent-me-us" },
      { name: "Fryeburg", slug: "fryeburg-me-us" },
      { name: "Gardiner", slug: "gardiner-me-us" },
      { name: "Gorham", slug: "gorham-me-us" },
      { name: "Hallowell", slug: "hallowell-me-us" },
      { name: "Hollis", slug: "hollis-me-us" },
      { name: "Houlton", slug: "houlton-me-us" },
      { name: "Jefferson", slug: "jefferson-me-us" },
      { name: "Kittery", slug: "kittery-me-us" },
      { name: "Lebanon", slug: "lebanon-me-us" },
      { name: "Lewiston", slug: "lewiston-me-us" },
      { name: "Lincoln", slug: "lincoln-me-us" },
      { name: "Manchester", slug: "manchester-me-us" },
      { name: "Millinocket", slug: "millinocket-me-us" },
      { name: "Newport", slug: "newport-me-us" },
      { name: "Old Town", slug: "old-town-me-us" },
      { name: "Palmyra", slug: "palmyra-me-us" },
      { name: "Portland", slug: "portland-me-us" },
      { name: "Raymond", slug: "raymond-me-us" },
      { name: "Rome", slug: "rome-me-us" },
      { name: "Rumford", slug: "rumford-me-us" },
      { name: "Saco", slug: "saco-me-us" },
      { name: "South Portland", slug: "south-portland-me-us" },
      { name: "Standish", slug: "standish-me-us" },
      { name: "Swanville", slug: "swanville-me-us" },
      { name: "Waldoboro", slug: "waldoboro-me-us" },
      { name: "Waterville", slug: "waterville-me-us" },
      { name: "Westbrook", slug: "westbrook-me-us" },
      { name: "Windham", slug: "windham-me-us" },
      { name: "Winslow", slug: "winslow-me-us" },
      { name: "Winthrop", slug: "winthrop-me-us" },
      { name: "Woolwich", slug: "woolwich-me-us" },
      { name: "York", slug: "york-me-us" },
    ],
    name: "Maine",
  },
  {
    locations: [
      { name: "Adrian", slug: "adrian-mi-us" },
      { name: "Ann Arbor", slug: "ann-arbor-mi-us" },
      { name: "Au Gres", slug: "au-gres-mi-us" },
      { name: "Auburn Hills", slug: "auburn-hills-mi-us" },
      { name: "Battle Creek", slug: "battle-creek-mi-us" },
      { name: "Bay City", slug: "bay-city-mi-us" },
      { name: "Bloomfield Hills", slug: "bloomfield-hills-mi-us" },
      { name: "Breedsville", slug: "breedsville-mi-us" },
      { name: "Burton", slug: "burton-mi-us" },
      { name: "Clinton Township", slug: "clinton-township-mi-us" },
      { name: "Davison", slug: "davison-mi-us" },
      { name: "Detroit", slug: "detroit-mi-us" },
      { name: "Evart", slug: "evart-mi-us" },
      { name: "Farmington Hills", slug: "farmington-hills-mi-us" },
      { name: "Flint", slug: "flint-mi-us" },
      { name: "Frederic", slug: "frederic-mi-us" },
      { name: "Georgetown Township", slug: "georgetown-township-mi-us" },
      { name: "Grand Rapids", slug: "grand-rapids-mi-us" },
      { name: "Grayling", slug: "grayling-mi-us" },
      { name: "Houghton", slug: "houghton-mi-us" },
      { name: "Inkster", slug: "inkster-mi-us" },
      { name: "Jackson", slug: "jackson-mi-us" },
      { name: "Kalamazoo", slug: "kalamazoo-mi-us" },
      { name: "Lansing", slug: "lansing-mi-us" },
      { name: "Macomb", slug: "macomb-mi-us" },
      { name: "Morenci", slug: "morenci-mi-us" },
      { name: "Mount Morris", slug: "mount-morris-mi-us" },
      { name: "Omer", slug: "omer-mi-us" },
      { name: "Portage", slug: "portage-mi-us" },
      { name: "Reading", slug: "reading-mi-us" },
      { name: "River Rouge", slug: "river-rouge-mi-us" },
      { name: "Royal Oak", slug: "royal-oak-mi-us" },
      {
        name: "Shelby Charter Township",
        slug: "shelby-charter-township-mi-us",
      },
      { name: "Southfield", slug: "southfield-mi-us" },
      { name: "Sterling Heights", slug: "sterling-heights-mi-us" },
      { name: "Traverse City", slug: "traverse-city-mi-us" },
      { name: "Troy", slug: "troy-mi-us" },
      { name: "Vassar", slug: "vassar-mi-us" },
      { name: "Walled Lake", slug: "walled-lake-mi-us" },
      { name: "Warren", slug: "warren-mi-us" },
      { name: "Wayne", slug: "wayne-mi-us" },
      {
        name: "West Bloomfield Township",
        slug: "west-bloomfield-township-mi-us",
      },
      { name: "Whitehall", slug: "whitehall-mi-us" },
      { name: "Ypsilanti", slug: "ypsilanti-mi-us" },
    ],
    name: "Michigan",
  },
  {
    locations: [
      { name: "Bloomington", slug: "bloomington-mn-us" },
      { name: "Eagan", slug: "eagan-mn-us" },
      { name: "Hibbing", slug: "hibbing-mn-us" },
      { name: "Minneapolis", slug: "minneapolis-mn-us" },
      { name: "Moorhead", slug: "moorhead-mn-us" },
      { name: "Rochester", slug: "rochester-mn-us" },
      { name: "Saint Cloud", slug: "saint-cloud-mn-us" },
      { name: "Saint Paul", slug: "saint-paul-mn-us" },
    ],
    name: "Minnesota",
  },
  {
    locations: [
      { name: "Blue Springs", slug: "blue-springs-mo-us" },
      { name: "Columbia", slug: "columbia-mo-us" },
      { name: "Florissant", slug: "florissant-mo-us" },
      { name: "Grand View", slug: "grand-view-mo-us" },
      { name: "Imperial", slug: "imperial-mo-us" },
      { name: "Joplin", slug: "joplin-mo-us" },
      { name: "Kansas City", slug: "kansas-city-mo-us" },
      { name: "Liberty", slug: "liberty-mo-us" },
      { name: "Saint Charles", slug: "saint-charles-mo-us" },
      { name: "Saint Joseph", slug: "saint-joseph-mo-us" },
      { name: "Springfield", slug: "springfield-mo-us" },
      { name: "St Louis", slug: "st-louis-mo-us" },
    ],
    name: "Missouri",
  },
  {
    locations: [
      { name: "Belgrade", slug: "belgrade-mt-us" },
      { name: "Big Sky", slug: "big-sky-mt-us" },
      { name: "Billings", slug: "billings-mt-us" },
      { name: "Black Eagle", slug: "black-eagle-mt-us" },
      { name: "Bozeman", slug: "bozeman-mt-us" },
      { name: "Butte", slug: "butte-mt-us" },
      { name: "Clancy", slug: "clancy-mt-us" },
      { name: "Columbia Falls", slug: "columbia-falls-mt-us" },
      { name: "Dillon", slug: "dillon-mt-us" },
      { name: "East Helena", slug: "east-helena-mt-us" },
      { name: "Ennis", slug: "ennis-mt-us" },
      { name: "Fort Peck", slug: "fort-peck-mt-us" },
      { name: "Helena", slug: "helena-mt-us" },
      { name: "Kalispell", slug: "kalispell-mt-us" },
      { name: "Lewistown", slug: "lewistown-mt-us" },
      { name: "Libby", slug: "libby-mt-us" },
      { name: "Livingston", slug: "livingston-mt-us" },
      { name: "Missoula", slug: "missoula-mt-us" },
      { name: "Sheridan", slug: "sheridan-mt-us" },
      { name: "Twin Bridges", slug: "twin-bridges-mt-us" },
      { name: "Vaughn", slug: "vaughn-mt-us" },
      { name: "Whitefish", slug: "whitefish-mt-us" },
    ],
    name: "Montana",
  },
  {
    locations: [
      { name: "Aberdeen", slug: "aberdeen-nc-us" },
      { name: "Asheville", slug: "asheville-nc-us" },
      { name: "Raleigh", slug: "raleigh-nc-us" },
      { name: "Smithfield", slug: "smithfield-nc-us" },
    ],
    name: "North Carolina",
  },
  {
    locations: [{ name: "Fargo", slug: "fargo-nd-us" }],
    name: "North Dakota",
  },
  {
    locations: [
      { name: "Dover", slug: "dover-nh-us" },
      { name: "Lebanon", slug: "lebanon-nh-us" },
      { name: "Merrimack", slug: "merrimack-nh-us" },
      { name: "Plymouth", slug: "plymouth-nh-us" },
    ],
    name: "New Hampshire",
  },
  {
    locations: [
      { name: "Aberdeen", slug: "aberdeen-township-nj-us" },
      { name: "Absecon", slug: "absecon-nj-us" },
      { name: "Asbury Park", slug: "asbury-park-nj-us" },
      { name: "Atco", slug: "atco-nj-us" },
      { name: "Atlantic City", slug: "atlantic-city-nj-us" },
      { name: "Audubon", slug: "audubon-nj-us" },
      { name: "Bayonne", slug: "bayonne-nj-us" },
      { name: "Bedminster", slug: "bedminster-nj-us" },
      { name: "Belleville", slug: "belleville-nj-us" },
      { name: "Belmar", slug: "belmar-nj-us" },
      { name: "Bellmawr", slug: "bellmawr-nj-us" },
      { name: "Belvidere", slug: "belvidere-nj-us" },
      { name: "Bergenfield", slug: "bergenfield-nj-us" },
      { name: "Berlin", slug: "berlin-nj-us" },
      { name: "Berlin Township", slug: "berlin-township-nj-us" },
      { name: "Bloomfield", slug: "bloomfield-nj-us" },
      { name: "Bloomsbury", slug: "bloomsbury-nj-us" },
      { name: "Bordentown", slug: "bordentown-nj-us" },
      { name: "Branchburg", slug: "branchburg-nj-us" },
      { name: "Brick Township", slug: "brick-township-nj-us" },
      { name: "Bridgeton", slug: "bridgeton-nj-us" },
      { name: "Bridgewater Township", slug: "bridgewater-township-nj-us" },
      { name: "Brigantine", slug: "brigantine-nj-us" },
      { name: "Buena", slug: "buena-nj-us" },
      { name: "Burlington", slug: "burlington-nj-us" },
      { name: "Byram Township", slug: "byram-township-nj-us" },
      { name: "Caldwell", slug: "caldwell-nj-us" },
      { name: "Camden", slug: "camden-nj-us" },
      { name: "Cape May", slug: "cape-may-nj-us" },
      { name: "Carlstadt", slug: "carlstadt-nj-us" },
      { name: "Carteret", slug: "carteret-nj-us" },
      { name: "Cedar Grove", slug: "cedar-grove-nj-us" },
      { name: "Chatham", slug: "chatham-nj-us" },
      { name: "Cherry Hill", slug: "cherry-hill-nj-us" },
      { name: "Chester Township", slug: "chester-township-nj-us" },
      { name: "Cinnaminson", slug: "cinnaminson-nj-us" },
      { name: "Clifton", slug: "clifton-nj-us" },
      { name: "Clinton", slug: "clinton-nj-us" },
      { name: "Collingswood", slug: "collingswood-nj-us" },
      { name: "Colts Neck", slug: "colts-neck-nj-us" },
      { name: "Cranbury Township", slug: "cranbury-township-nj-us" },
      { name: "Cranford", slug: "cranford-nj-us" },
      { name: "Cresskill", slug: "cresskill-nj-us" },
      { name: "Delanco", slug: "delanco-nj-us" },
      { name: "Denville", slug: "denville-nj-us" },
      { name: "Deptford", slug: "deptford-nj-us" },
      { name: "East Brunswick", slug: "east-brunswick-nj-us" },
      { name: "East Orange", slug: "east-orange-nj-us" },
      { name: "East Rutherford", slug: "east-rutherford-nj-us" },
      { name: "East Windsor", slug: "east-windsor-nj-us" },
      { name: "Eatontown", slug: "eatontown-nj-us" },
      { name: "Edgewater Park", slug: "edgewater-park-nj-us" },
      { name: "Edison", slug: "edison-nj-us" },
      { name: "Egg Harbor Township", slug: "egg-harbor-township-nj-us" },
      { name: "Elizabeth", slug: "elizabeth-nj-us" },
      { name: "Elmwood Park", slug: "elmwood-park-nj-us" },
      { name: "Emerson", slug: "emerson-nj-us" },
      { name: "Englewood Cliffs", slug: "englewood-cliffs-nj-us" },
      { name: "Englewood", slug: "englewood-nj-us" },
      { name: "Evesham", slug: "evesham-nj-us" },
      { name: "Ewing Township", slug: "ewing-township-nj-us" },
      { name: "Fair Lawn", slug: "fair-lawn-nj-us" },
      { name: "Fairfield", slug: "fairfield-nj-us" },
      { name: "Flemington", slug: "flemington-nj-us" },
      { name: "Florence", slug: "florence-nj-us" },
      { name: "Florham Park", slug: "florham-park-nj-us" },
      { name: "Fort Lee", slug: "fort-lee-nj-us" },
      { name: "Franklin Township", slug: "franklin-township-nj-us" },
      { name: "Freehold Township", slug: "freehold-township-nj-us" },
      { name: "Galloway", slug: "galloway-nj-us" },
      { name: "Garfield", slug: "garfield-nj-us" },
      { name: "Glassboro", slug: "glassboro-nj-us" },
      { name: "Glen Ridge", slug: "glen-ridge-nj-us" },
      { name: "Glen Rock", slug: "glen-rock-nj-us" },
      { name: "Gloucester Township", slug: "gloucester-township-nj-us" },
      { name: "Green Brook Township", slug: "green-brook-township-nj-us" },
      { name: "Hackensack", slug: "hackensack-nj-us" },
      { name: "Hackettstown", slug: "hackettstown-nj-us" },
      { name: "Haddon Heights", slug: "haddon-heights-nj-us" },
      { name: "Haddonfield", slug: "haddonfield-nj-us" },
      { name: "Hainesport", slug: "hainesport-nj-us" },
      { name: "Haledon", slug: "haledon-nj-us" },
      { name: "Hamburg", slug: "hamburg-nj-us" },
      { name: "Hamilton", slug: "hamilton-township-nj-us" },
      { name: "Hammonton", slug: "hammonton-nj-us" },
      { name: "Hanover", slug: "hanover-nj-us" },
      { name: "Harrison Township", slug: "harrison-township-nj-us" },
      { name: "Hasbrouck Heights", slug: "hasbrouck-heights-nj-us" },
      { name: "Hazlet", slug: "hazlet-nj-us" },
      { name: "Highland Park", slug: "highland-park-nj-us" },
      { name: "Hillsborough Township", slug: "hillsborough-township-nj-us" },
      { name: "Hillsdale", slug: "hillsdale-nj-us" },
      { name: "Hoboken", slug: "hoboken-nj-us" },
      { name: "Holmdel", slug: "holmdel-nj-us" },
      { name: "Hopatcong", slug: "hopatcong-nj-us" },
      { name: "Howell Township", slug: "howell-township-nj-us" },
      { name: "Irvington", slug: "irvington-nj-us" },
      { name: "Jackson Township", slug: "jackson-township-nj-us" },
      { name: "Jamesburg", slug: "jamesburg-nj-us" },
      { name: "Jefferson", slug: "jefferson-nj-us" },
      { name: "Jersey City", slug: "jersey-city-nj-us" },
      { name: "Keansburg", slug: "keansburg-nj-us" },
      { name: "Kearny", slug: "kearny-nj-us" },
      { name: "Knowlton Township", slug: "knowlton-township-nj-us" },
      { name: "Lacey Township", slug: "lacey-township-nj-us" },
      { name: "Lakehurst", slug: "lakehurst-nj-us" },
      { name: "Lakewood", slug: "lakewood-nj-us" },
      { name: "Lambertville", slug: "lambertville-nj-us" },
      { name: "Lavallette", slug: "lavallette-nj-us" },
      { name: "Lawrence Township", slug: "lawrence-township-nj-us" },
      { name: "Lebanon", slug: "lebanon-nj-us" },
      { name: "Lincoln Park", slug: "lincoln-park-nj-us" },
      { name: "Linden", slug: "linden-nj-us" },
      { name: "Lindenwold", slug: "lindenwold-nj-us" },
      { name: "Linwood", slug: "linwood-nj-us" },
      { name: "Little Ferry", slug: "little-ferry-nj-us" },
      { name: "Little Silver", slug: "little-silver-nj-us" },
      { name: "Livingston", slug: "livingston-nj-us" },
      { name: "Lodi", slug: "lodi-nj-us" },
      { name: "Long Branch", slug: "long-branch-nj-us" },
      { name: "Lumberton", slug: "lumberton-nj-us" },
      { name: "Lyndhurst", slug: "lyndhurst-nj-us" },
      { name: "Mahwah", slug: "mahwah-nj-us" },
      { name: "Manalapan Township", slug: "manalapan-township-nj-us" },
      { name: "Manasquan", slug: "manasquan-nj-us" },
      { name: "Mantua Township", slug: "mantua-township-nj-us" },
      { name: "Maplewood", slug: "maplewood-nj-us" },
      { name: "Marlboro", slug: "marlboro-nj-us" },
      { name: "Marmora", slug: "marmora-nj-us" },
      { name: "Matawan", slug: "matawan-nj-us" },
      { name: "Maywood", slug: "maywood-nj-us" },
      { name: "Medford", slug: "medford-nj-us" },
      { name: "Merchantville", slug: "merchantville-nj-us" },
      { name: "Metuchen", slug: "metuchen-nj-us" },
      { name: "Middle Township", slug: "middle-township-nj-us" },
      { name: "Middletown Township", slug: "middletown-township-nj-us" },
      { name: "Millburn", slug: "millburn-nj-us" },
      { name: "Millville", slug: "millville-nj-us" },
      { name: "Monroe", slug: "monroe-nj-us" },
      { name: "Monroe Township", slug: "monroe-township-nj-us" },
      { name: "Montclair", slug: "montclair-nj-us" },
      { name: "Montville", slug: "montville-nj-us" },
      { name: "Moonachie", slug: "moonachie-nj-us" },
      { name: "Moorestown", slug: "moorestown-nj-us" },
      { name: "Morris Plains", slug: "morris-plains-nj-us" },
      { name: "Morristown", slug: "morristown-nj-us" },
      { name: "Mount Holly", slug: "mount-holly-nj-us" },
      { name: "Mount Laurel Township", slug: "mount-laurel-township-nj-us" },
      { name: "Mount Olive", slug: "mount-olive-nj-us" },
      { name: "Mountain Lakes", slug: "mountain-lakes-nj-us" },
      { name: "Neptune City", slug: "neptune-city-nj-us" },
      { name: "New Brunswick", slug: "new-brunswick-nj-us" },
      { name: "New Providence", slug: "new-providence-nj-us" },
      { name: "Newark", slug: "newark-nj-us" },
      { name: "Newton", slug: "newton-nj-us" },
      { name: "North Bergen", slug: "north-bergen-nj-us" },
      {
        name: "North Brunswick Township",
        slug: "north-brunswick-township-nj-us",
      },
      { name: "North Plainfield", slug: "north-plainfield-nj-us" },
      { name: "Northfield", slug: "northfield-nj-us" },
      { name: "Nutley", slug: "nutley-nj-us" },
      { name: "Oakland", slug: "oakland-nj-us" },
      { name: "Oaklyn", slug: "oaklyn-nj-us" },
      { name: "Ocean City", slug: "ocean-city-nj-us" },
      { name: "Ocean Township", slug: "ocean-township-nj-us" },
      { name: "Old Bridge", slug: "old-bridge-nj-us" },
      { name: "Oradell", slug: "oradell-nj-us" },
      { name: "Palisades Park", slug: "palisades-park-nj-us" },
      { name: "Paramus", slug: "paramus-nj-us" },
      { name: "Parsippany Troy Hills", slug: "parsippany-troy-hills-nj-us" },
      { name: "Passaic", slug: "passaic-nj-us" },
      { name: "Paterson", slug: "paterson-nj-us" },
      { name: "Pemberton", slug: "pemberton-nj-us" },
      { name: "Pennington", slug: "pennington-nj-us" },
      { name: "Pennsauken Township", slug: "pennsauken-township-nj-us" },
      { name: "Pequannock Township", slug: "pequannock-township-nj-us" },
      { name: "Perth Amboy", slug: "perth-amboy-nj-us" },
      { name: "Phillipsburg", slug: "phillipsburg-nj-us" },
      { name: "Piscataway", slug: "piscataway-nj-us" },
      { name: "Plainfield", slug: "plainfield-nj-us" },
      { name: "Plainsboro Township", slug: "plainsboro-township-nj-us" },
      { name: "Pleasantville", slug: "pleasantville-nj-us" },
      { name: "Point Pleasant", slug: "point-pleasant-nj-us" },
      { name: "Pompton Lakes", slug: "pompton-lakes-nj-us" },
      { name: "Princeton", slug: "princeton-nj-us" },
      { name: "Rahway", slug: "rahway-nj-us" },
      { name: "Ramsey", slug: "ramsey-nj-us" },
      { name: "Randolph", slug: "randolph-nj-us" },
      { name: "Raritan", slug: "raritan-nj-us" },
      { name: "Red Bank", slug: "red-bank-nj-us" },
      { name: "Ridgewood", slug: "ridgewood-nj-us" },
      { name: "River Vale", slug: "river-vale-nj-us" },
      { name: "Riverdale", slug: "riverdale-nj-us" },
      { name: "Robbinsville Township", slug: "robbinsville-township-nj-us" },
      { name: "Rochelle Park", slug: "rochelle-park-nj-us" },
      { name: "Roselle", slug: "roselle-nj-us" },
      { name: "Roselle Park", slug: "roselle-park-nj-us" },
      { name: "Roxbury Township", slug: "roxbury-township-nj-us" },
      { name: "Runnemede", slug: "runnemede-nj-us" },
      { name: "Rutherford", slug: "rutherford-nj-us" },
      { name: "Saddle Brook", slug: "saddle-brook-nj-us" },
      { name: "Salem", slug: "salem-nj-us" },
      { name: "Sayreville", slug: "sayreville-nj-us" },
      { name: "Scotch Plains", slug: "scotch-plains-nj-us" },
      { name: "Sea Bright", slug: "sea-bright-nj-us" },
      { name: "Sea Girt", slug: "sea-girt-nj-us" },
      { name: "Sea Isle City", slug: "sea-isle-city-nj-us" },
      { name: "Secaucus", slug: "secaucus-nj-us" },
      { name: "Shrewsbury", slug: "shrewsbury-nj-us" },
      { name: "Somerdale", slug: "somerdale-nj-us" },
      { name: "Somers Point", slug: "somers-point-nj-us" },
      { name: "Somerville", slug: "somerville-nj-us" },
      { name: "South Amboy", slug: "south-amboy-nj-us" },
      { name: "South Bound Brook", slug: "south-bound-brook-nj-us" },
      {
        name: "South Brunswick Township",
        slug: "south-brunswick-township-nj-us",
      },
      { name: "South Jersey", slug: "south-jersey-nj-us" },
      { name: "South Orange", slug: "south-orange-nj-us" },
      { name: "South Plainfield", slug: "south-plainfield-nj-us" },
      { name: "Sparta Township", slug: "sparta-township-nj-us" },
      { name: "Springfield", slug: "springfield-nj-us" },
      { name: "Stafford", slug: "stafford-township-nj-us" },
      { name: "Stanhope", slug: "stanhope-nj-us" },
      { name: "Stratford", slug: "stratford-nj-us" },
      { name: "Summit", slug: "summit-nj-us" },
      { name: "Tabernacle", slug: "tabernacle-nj-us" },
      { name: "Teaneck", slug: "teaneck-nj-us" },
      { name: "Tinton Falls", slug: "tinton-falls-nj-us" },
      { name: "Toms River", slug: "toms-river-nj-us" },
      { name: "Totowa", slug: "totowa-nj-us" },
      { name: "Trenton", slug: "trenton-nj-us" },
      { name: "Union City", slug: "union-city-nj-us" },
      { name: "Union", slug: "union-nj-us" },
      { name: "Upper Freehold", slug: "upper-freehold-nj-us" },
      { name: "Ventnor City", slug: "ventnor-city-nj-us" },
      { name: "Verona", slug: "verona-nj-us" },
      { name: "Vineland", slug: "vineland-nj-us" },
      { name: "Voorhees Township", slug: "voorhees-township-nj-us" },
      { name: "Wall Township", slug: "wall-township-nj-us" },
      { name: "Wantage", slug: "wantage-nj-us" },
      { name: "Warren", slug: "warren-nj-us" },
      { name: "Washington Township", slug: "washington-township-nj-us" },
      { name: "Waterford", slug: "waterford-nj-us" },
      { name: "Wayne", slug: "wayne-nj-us" },
      { name: "Wenonah", slug: "wenonah-nj-us" },
      { name: "West Deptford", slug: "west-deptford-nj-us" },
      { name: "West Milford", slug: "west-milford-nj-us" },
      { name: "West Orange", slug: "west-orange-nj-us" },
      { name: "West Windsor Township", slug: "west-windsor-township-nj-us" },
      { name: "Westfield", slug: "westfield-nj-us" },
      { name: "Westville", slug: "westville-nj-us" },
      { name: "Westwood", slug: "westwood-nj-us" },
      { name: "Wildwood", slug: "wildwood-nj-us" },
      { name: "Willingboro", slug: "willingboro-nj-us" },
      { name: "Winslow Township", slug: "winslow-township-nj-us" },
      { name: "Woodbridge Township", slug: "woodbridge-township-nj-us" },
      { name: "Woodbury Heights", slug: "woodbury-heights-nj-us" },
      { name: "Woodbury", slug: "woodbury-nj-us" },
      { name: "Woodland Park", slug: "woodland-park-nj-us" },
      { name: "Woodstown", slug: "woodstown-nj-us" },
      { name: "Wyckoff", slug: "wyckoff-nj-us" },
    ],
    name: "New Jersey",
  },

  {
    locations: [
      { name: "Alamogordo", slug: "alamogordo-nm-us" },
      { name: "Albuquerque", slug: "albuquerque-nm-us" },
      { name: "Artesia", slug: "artesia-nm-us" },
      { name: "Bernalillo", slug: "bernalillo-nm-us" },
      { name: "Carlsbad", slug: "carlsbad-nm-us" },
      { name: "Clovis", slug: "clovis-nm-us" },
      { name: "Española", slug: "espa%C3%B1ola-nm-us" },
      { name: "Farmington", slug: "farmington-nm-us" },
      { name: "Gallup", slug: "gallup-nm-us" },
      { name: "Grants", slug: "grants-nm-us" },
      { name: "Hobbs", slug: "hobbs-nm-us" },
      { name: "Las Cruces", slug: "las-cruces-nm-us" },
      { name: "Las Vegas", slug: "las-vegas-nm-us" },
      { name: "Los Lunas", slug: "los-lunas-nm-us" },
      {
        name: "Los Ranchos De Albuquerque",
        slug: "los-ranchos-de-albuquerque-nm-us",
      },
      { name: "Placitas", slug: "placitas-nm-us" },
      { name: "Pojoaque", slug: "pojoaque-nm-us" },
      { name: "Rio Rancho", slug: "rio-rancho-nm-us" },
      { name: "Roswell", slug: "roswell-nm-us" },
      { name: "Ruidoso", slug: "ruidoso-nm-us" },
      { name: "Santa Fe", slug: "santa-fe-nm-us" },
      { name: "Silver City", slug: "silver-city-nm-us" },
      { name: "Socorro", slug: "socorro-nm-us" },
      { name: "Sunland Park", slug: "sunland-park-nm-us" },
      { name: "Taos", slug: "taos-nm-us" },
      {
        name: "Truth Or Consequences",
        slug: "truth-or-consequences-nm-us",
      },
    ],
    name: "New Mexico",
  },
  {
    locations: [
      { name: "Carson City", slug: "carson-city-nv-us" },
      { name: "Ely", slug: "ely-nv-us" },
      { name: "Fallon", slug: "fallon-nv-us" },
      { name: "Fernley", slug: "fernley-nv-us" },
      { name: "Henderson", slug: "henderson-nv-us" },
      { name: "Incline Village", slug: "incline-village-nv-us" },
      { name: "Las Vegas", slug: "las-vegas-nv-us" },
      { name: "Laughlin", slug: "laughlin-nv-us" },
      { name: "Lovelock", slug: "lovelock-nv-us" },
      { name: "Mesquite", slug: "mesquite-nv-us" },
      { name: "North Las Vegas", slug: "north-las-vegas-nv-us" },
      { name: "Pahrump", slug: "pahrump-nv-us" },
      { name: "Reno", slug: "reno-nv-us" },
      { name: "Spanish Springs", slug: "spanish-springs-nv-us" },
      { name: "Sparks", slug: "sparks-nv-us" },
      { name: "Sun Valley", slug: "sun-valley-nv-us" },
      { name: "Yerington", slug: "yerington-nv-us" },
    ],
    name: "Nevada",
  },
  {
    locations: [
      { name: "Albany", slug: "albany-ny-us" },
      { name: "Bardonia", slug: "bardonia-ny-us" },
      { name: "Buffalo", slug: "buffalo-ny-us" },
      { name: "Carle Place", slug: "carle-place-ny-us" },
      { name: "Farmingdale", slug: "farmingdale-ny-us" },
      { name: "Goshen", slug: "goshen-ny-us" },
      { name: "Johnson City", slug: "johnson-city-ny-us" },
      { name: "Kingston", slug: "kingston-ny-us" },
      { name: "Liverpool", slug: "liverpool-ny-us" },
      { name: "Merrick", slug: "merrick-ny-us" },
      { name: "Middletown", slug: "middletown-ny-us" },
      { name: "Monroe", slug: "monroe-ny-us" },
      { name: "New Hartford", slug: "new-hartford-ny-us" },
      { name: "New Hyde Park", slug: "new-hyde-park-ny-us" },
      { name: "New York", slug: "new-york-ny-us" },
      { name: "Newburgh", slug: "newburgh-ny-us" },
      { name: "Plattsburgh", slug: "plattsburgh-ny-us" },
      { name: "Riverhead", slug: "riverhead-ny-us" },
      { name: "Rochester", slug: "rochester-ny-us" },
      { name: "Syracuse", slug: "syracuse-ny-us" },
      { name: "Wappingers Falls", slug: "wappingers-falls-ny-us" },
      { name: "White Plains", slug: "white-plains-ny-us" },
      { name: "Yonkers", slug: "yonkers-ny-us" },
    ],
    name: "New York",
  },
  {
    locations: [
      { name: "Akron", slug: "akron-oh-us" },
      { name: "Athens", slug: "athens-oh-us" },
      { name: "Canton", slug: "canton-oh-us" },
      { name: "Cleveland", slug: "cleveland-oh-us" },
      { name: "Columbus", slug: "columbus-oh-us" },
      { name: "Cuyahoga Falls", slug: "cuyahoga-falls-oh-us" },
      { name: "Garfield Heights", slug: "garfield-heights-oh-us" },
      { name: "Jackson", slug: "jackson-oh-us" },
      { name: "Newark", slug: "newark-oh-us" },
      { name: "Steubenville", slug: "steubenville-oh-us" },
      { name: "Warren", slug: "warren-oh-us" },
      { name: "Wickliffe", slug: "wickliffe-oh-us" },
      { name: "Wintersville", slug: "wintersville-oh-us" },
    ],
    name: "Ohio",
  },
  {
    locations: [
      { name: "Ada", slug: "ada-ok-us" },
      { name: "Afton", slug: "afton-ok-us" },
      { name: "Altus", slug: "altus-ok-us" },
      { name: "Ardmore", slug: "ardmore-ok-us" },
      { name: "Atoka", slug: "atoka-ok-us" },
      { name: "Bartlesville", slug: "bartlesville-ok-us" },
      { name: "Broken Arrow", slug: "broken-arrow-ok-us" },
      { name: "Catoosa", slug: "catoosa-ok-us" },
      { name: "Chickasha", slug: "chickasha-ok-us" },
      { name: "Claremore", slug: "claremore-ok-us" },
      { name: "Coweta", slug: "coweta-ok-us" },
      { name: "Davis", slug: "davis-ok-us" },
      { name: "Del City", slug: "del-city-ok-us" },
      { name: "Dewey", slug: "dewey-ok-us" },
      { name: "Drumright", slug: "drumright-ok-us" },
      { name: "Duncan", slug: "duncan-ok-us" },
      { name: "Durant", slug: "durant-ok-us" },
      { name: "Edmond", slug: "edmond-ok-us" },
      { name: "El Reno", slug: "el-reno-ok-us" },
      { name: "Elmore City", slug: "elmore-city-ok-us" },
      { name: "Enid", slug: "enid-ok-us" },
      { name: "Eufaula", slug: "eufaula-ok-us" },
      { name: "Fairfax", slug: "fairfax-ok-us" },
      { name: "Glenpool", slug: "glenpool-ok-us" },
      { name: "Guthrie", slug: "guthrie-ok-us" },
      { name: "Lawton", slug: "lawton-ok-us" },
      { name: "Madill", slug: "madill-ok-us" },
      { name: "Marietta", slug: "marietta-ok-us" },
      { name: "Mcalester", slug: "mcalester-ok-us" },
      { name: "Miami", slug: "miami-ok-us" },
      { name: "Midwest City", slug: "midwest-city-ok-us" },
      { name: "Moore", slug: "moore-ok-us" },
      { name: "Mustang", slug: "mustang-ok-us" },
      { name: "New Cordell", slug: "new-cordell-ok-us" },
      { name: "Newcastle", slug: "newcastle-ok-us" },
      { name: "Noble", slug: "noble-ok-us" },
      { name: "Norman", slug: "norman-ok-us" },
      { name: "Nowata", slug: "nowata-ok-us" },
      { name: "Oklahoma City", slug: "oklahoma-city-ok-us" },
      { name: "Okmulgee", slug: "okmulgee-ok-us" },
      { name: "Owasso", slug: "owasso-ok-us" },
      { name: "Pauls Valley", slug: "pauls-valley-ok-us" },
      { name: "Purcell", slug: "purcell-ok-us" },
      { name: "Roland", slug: "roland-ok-us" },
      { name: "Sallisaw", slug: "sallisaw-ok-us" },
      { name: "Sand Springs", slug: "sand-springs-ok-us" },
      { name: "Sapulpa", slug: "sapulpa-ok-us" },
      { name: "Sayre", slug: "sayre-ok-us" },
      { name: "Shawnee", slug: "shawnee-ok-us" },
      { name: "Skiatook", slug: "skiatook-ok-us" },
      { name: "South Coffeyville", slug: "south-coffeyville-ok-us" },
      { name: "Stillwater", slug: "stillwater-ok-us" },
      { name: "Tahlequah", slug: "tahlequah-ok-us" },
      { name: "Talihina", slug: "talihina-ok-us" },
      { name: "The Village", slug: "the-village-ok-us" },
      { name: "Tulsa", slug: "tulsa-ok-us" },
      { name: "Wagoner", slug: "wagoner-ok-us" },
      { name: "Warr Acres", slug: "warr-acres-ok-us" },
      { name: "Yukon", slug: "yukon-ok-us" },
    ],
    name: "Oklahoma",
  },
  {
    locations: [
      { name: "Albany", slug: "albany-or-us" },
      { name: "Ashland", slug: "ashland-or-us" },
      { name: "Astoria", slug: "astoria-or-us" },
      { name: "Bandon", slug: "bandon-or-us" },
      { name: "Banks", slug: "banks-or-us" },
      { name: "Beaverton", slug: "beaverton-or-us" },
      { name: "Bend", slug: "bend-or-us" },
      { name: "Brookings", slug: "brookings-or-us" },
      { name: "Brownsville", slug: "brownsville-or-us" },
      { name: "Cannon Beach", slug: "cannon-beach-or-us" },
      { name: "Cave Junction", slug: "cave-junction-or-us" },
      { name: "Central Point", slug: "central-point-or-us" },
      { name: "Charleston", slug: "charleston-or-us" },
      { name: "Clackamas", slug: "clackamas-or-us" },
      { name: "Clatskanie", slug: "clatskanie-or-us" },
      { name: "Cloverdale", slug: "cloverdale-or-us" },
      { name: "Coos Bay", slug: "coos-bay-or-us" },
      { name: "Corvallis", slug: "corvallis-or-us" },
      { name: "Cottage Grove", slug: "cottage-grove-or-us" },
      { name: "Damascus", slug: "damascus-or-us" },
      { name: "Depoe Bay", slug: "depoe-bay-or-us" },
      { name: "Detroit", slug: "detroit-or-us" },
      { name: "Drain", slug: "drain-or-us" },
      { name: "Dundee", slug: "dundee-or-us" },
      { name: "Eugene", slug: "eugene-or-us" },
      { name: "Florence", slug: "florence-or-us" },
      { name: "Forest Grove", slug: "forest-grove-or-us" },
      { name: "Gates", slug: "gates-or-us" },
      { name: "Gearhart", slug: "gearhart-or-us" },
      { name: "Gladstone", slug: "gladstone-or-us" },
      { name: "Gold Beach", slug: "gold-beach-or-us" },
      { name: "Gold Hill", slug: "gold-hill-or-us" },
      { name: "Grants Pass", slug: "grants-pass-or-us" },
      { name: "Gresham", slug: "gresham-or-us" },
      { name: "Happy Valley", slug: "happy-valley-or-us" },
      { name: "Hillsboro", slug: "hillsboro-or-us" },
      { name: "Hines", slug: "hines-or-us" },
      { name: "Hood River", slug: "hood-river-or-us" },
      { name: "Hubbard", slug: "hubbard-or-us" },
      { name: "Huntington", slug: "huntington-or-us" },
      { name: "Independence", slug: "independence-or-us" },
      { name: "Keizer", slug: "keizer-or-us" },
      { name: "Kerby", slug: "kerby-or-us" },
      { name: "King City", slug: "king-city-or-us" },
      { name: "Klamath Falls", slug: "klamath-falls-or-us" },
      { name: "La Grande", slug: "la-grande-or-us" },
      { name: "La Pine", slug: "la-pine-or-us" },
      { name: "Lakeview", slug: "lakeview-or-us" },
      { name: "Lebanon", slug: "lebanon-or-us" },
      { name: "Lincoln City", slug: "lincoln-city-or-us" },
      { name: "Madras", slug: "madras-or-us" },
      { name: "Manzanita", slug: "manzanita-or-us" },
      { name: "Mapleton", slug: "mapleton-or-us" },
      { name: "Mcminnville", slug: "mcminnville-or-us" },
      { name: "Medford", slug: "medford-or-us" },
      { name: "Merlin", slug: "merlin-or-us" },
      { name: "Milwaukie", slug: "milwaukie-or-us" },
      { name: "Molalla", slug: "molalla-or-us" },
      { name: "Monmouth", slug: "monmouth-or-us" },
      { name: "Mount Hood Village", slug: "mount-hood-village-or-us" },
      { name: "Myrtle Creek", slug: "myrtle-creek-or-us" },
      { name: "Newberg", slug: "newberg-or-us" },
      { name: "Newport", slug: "newport-or-us" },
      { name: "North Bend", slug: "north-bend-or-us" },
      { name: "Oak Grove", slug: "oak-grove-or-us" },
      { name: "Oakridge", slug: "oakridge-or-us" },
      { name: "Ontario", slug: "ontario-or-us" },
      { name: "Oregon City", slug: "oregon-city-or-us" },
      { name: "Otis", slug: "otis-or-us" },
      { name: "Pendleton", slug: "pendleton-or-us" },
      { name: "Phoenix", slug: "phoenix-or-us" },
      { name: "Port Orford", slug: "port-orford-or-us" },
      { name: "Portland", slug: "portland-or-us" },
      { name: "Rainier", slug: "rainier-or-us" },
      { name: "Reedsport", slug: "reedsport-or-us" },
      { name: "Rhododendron", slug: "rhododendron-or-us" },
      { name: "Rockaway Beach", slug: "rockaway-beach-or-us" },
      { name: "Rogue River", slug: "rogue-river-or-us" },
      { name: "Roseburg", slug: "roseburg-or-us" },
      { name: "Saint Helens", slug: "saint-helens-or-us" },
      { name: "Salem", slug: "salem-or-us" },
      { name: "Scappoose", slug: "scappoose-or-us" },
      { name: "Seaside", slug: "seaside-or-us" },
      { name: "Shady Cove", slug: "shady-cove-or-us" },
      { name: "Sheridan", slug: "sheridan-or-us" },
      { name: "Sherwood", slug: "sherwood-or-us" },
      { name: "Silverton", slug: "silverton-or-us" },
      { name: "Springfield", slug: "springfield-or-us" },
      { name: "Stayton", slug: "stayton-or-us" },
      { name: "Sumpter", slug: "sumpter-or-us" },
      { name: "Sweet Home", slug: "sweet-home-or-us" },
      { name: "Talent", slug: "talent-or-us" },
      { name: "Tangent", slug: "tangent-or-us" },
      { name: "The Dalles", slug: "the-dalles-or-us" },
      { name: "Tigard", slug: "tigard-or-us" },
      { name: "Tillamook", slug: "tillamook-or-us" },
      { name: "Toledo", slug: "toledo-or-us" },
      { name: "Turner", slug: "turner-or-us" },
      { name: "Veneta", slug: "veneta-or-us" },
      { name: "Vernonia", slug: "vernonia-or-us" },
      { name: "Waldport", slug: "waldport-or-us" },
      { name: "Warren", slug: "warren-or-us" },
      { name: "Willamina", slug: "willamina-or-us" },
      { name: "Wood Village", slug: "wood-village-or-us" },
      { name: "Woodburn", slug: "woodburn-or-us" },
      { name: "Yachats", slug: "yachats-or-us" },
    ],
    name: "Oregon",
  },
  {
    locations: [
      { name: "Abington", slug: "abington-pa-us" },
      { name: "Allentown", slug: "allentown-pa-us" },
      { name: "Altoona", slug: "altoona-pa-us" },
      { name: "Bensalem", slug: "bensalem-pa-us" },
      { name: "Bethlehem", slug: "bethlehem-pa-us" },
      { name: "Bradford", slug: "bradford-pa-us" },
      { name: "Brookville", slug: "brookville-pa-us" },
      { name: "Butler", slug: "butler-pa-us" },
      { name: "Carlisle", slug: "carlisle-pa-us" },
      { name: "Chambersburg", slug: "chambersburg-pa-us" },
      { name: "Cranberry Township", slug: "cranberry-township-pa-us" },
      { name: "Devon", slug: "devon-pa-us" },
      { name: "Dubois", slug: "dubois-pa-us" },
      { name: "Edwardsville", slug: "edwardsville-pa-us" },
      { name: "Elkins Park", slug: "elkins-park-pa-us" },
      { name: "Enola", slug: "enola-pa-us" },
      { name: "Erie", slug: "erie-pa-us" },
      { name: "Gettysburg", slug: "gettysburg-pa-us" },
      { name: "Greensburg", slug: "greensburg-pa-us" },
      { name: "Hanover", slug: "hanover-pa-us" },
      { name: "King Of Prussia", slug: "king-of-prussia-pa-us" },
      { name: "Lancaster", slug: "lancaster-pa-us" },
      { name: "Lebanon", slug: "lebanon-pa-us" },
      { name: "Levittown", slug: "levittown-pa-us" },
      { name: "Malvern", slug: "malvern-pa-us" },
      { name: "Morton", slug: "morton-pa-us" },
      { name: "New Kensington", slug: "new-kensington-pa-us" },
      { name: "Norristown", slug: "norristown-pa-us" },
      { name: "Philadelphia", slug: "philadelphia-pa-us" },
      { name: "Phoenixville", slug: "phoenixville-pa-us" },
      { name: "Pittsburgh", slug: "pittsburgh-pa-us" },
      { name: "Plymouth Meeting", slug: "plymouth-meeting-pa-us" },
      { name: "Reading", slug: "reading-pa-us" },
      { name: "Scranton", slug: "scranton-pa-us" },
      { name: "Sellersville", slug: "sellersville-pa-us" },
      { name: "State College", slug: "state-college-pa-us" },
      { name: "Steelton", slug: "steelton-pa-us" },
      { name: "Uniontown", slug: "uniontown-pa-us" },
      { name: "Washington", slug: "washington-pa-us" },
      { name: "Wilkes-Barre", slug: "wilkes-barre-pa-us" },
      { name: "Williamsport", slug: "williamsport-pa-us" },
      { name: "Zelienople", slug: "zelienople-pa-us" },
    ],
    name: "Pennsylvania",
  },
  {
    locations: [
      { name: "Portsmouth", slug: "portsmouth-ri-us" },
      { name: "Providence", slug: "providence-ri-us" },
      { name: "Warwick", slug: "warwick-ri-us" },
    ],
    name: "Rhode Island",
  },
  {
    locations: [{ name: "Buffalo", slug: "buffalo-sd-us" }],
    name: "South Dakota",
  },
  {
    locations: [
      { name: "Bristol", slug: "bristol-tn-us" },
      { name: "Elizabethton", slug: "elizabethton-tn-us" },
      { name: "Johnson City", slug: "johnson-city-tn-us" },
      { name: "Kingsport", slug: "kingsport-tn-us" },
      { name: "Knoxville", slug: "knoxville-tn-us" },
      { name: "Maryville", slug: "maryville-tn-us" },
      { name: "Memphis", slug: "memphis-tn-us" },
      { name: "Nashville", slug: "nashville-tn-us" },
    ],
    name: "Tennessee",
  },
  {
    locations: [
      { name: "Allen", slug: "allen-tx-us" },
      { name: "Dallas", slug: "dallas-tx-us" },
      { name: "Plano", slug: "plano-tx-us" },
      { name: "Wichita Falls", slug: "wichita-falls-tx-us" },
    ],
    name: "Texas",
  },
  {
    locations: [
      { name: "Bennington", slug: "bennington-vt-us" },
      { name: "Brattleboro", slug: "brattleboro-vt-us" },
      { name: "Burlington", slug: "burlington-vt-us" },
      { name: "Middlebury", slug: "middlebury-vt-us" },
      { name: "Montpelier", slug: "montpelier-vt-us" },
      { name: "South Burlington", slug: "south-burlington-vt-us" },
    ],
    name: "Vermont",
  },
  {
    locations: [
      { name: "Abingdon", slug: "abingdon-va-us" },
      { name: "Alexandria", slug: "alexandria-va-us" },
      { name: "Alleghany", slug: "alleghany-va-us" },
      { name: "Annandale", slug: "annandale-va-us" },
      { name: "Arlington", slug: "arlington-va-us" },
      { name: "Ashburn", slug: "ashburn-va-us" },
      { name: "Bedford", slug: "bedford-va-us" },
      { name: "Blacksburg", slug: "blacksburg-va-us" },
      { name: "Bridgewater", slug: "bridgewater-va-us" },
      { name: "Bristol", slug: "bristol-va-us" },
      { name: "Bristow", slug: "bristow-va-us" },
      { name: "Broadway", slug: "broadway-va-us" },
      { name: "Burke", slug: "burke-va-us" },
      { name: "Cedar Bluff", slug: "cedar-bluff-va-us" },
      { name: "Centreville", slug: "centreville-va-us" },
      { name: "Charlottesville", slug: "charlottesville-va-us" },
      { name: "Chesapeake", slug: "chesapeake-va-us" },
      { name: "Chester", slug: "chester-va-us" },
      { name: "Christiansburg", slug: "christiansburg-va-us" },
      { name: "Colonial Heights", slug: "colonial-heights-va-us" },
      { name: "Crozet", slug: "crozet-va-us" },
      { name: "Danville", slug: "danville-va-us" },
      { name: "Dulles", slug: "dulles-va-us" },
      { name: "Fairfax", slug: "fairfax-va-us" },
      { name: "Fort Lee", slug: "fort-lee-va-us" },
      { name: "Fredericksburg", slug: "fredericksburg-va-us" },
      { name: "Galax", slug: "galax-va-us" },
      { name: "Glen Allen", slug: "glen-allen-va-us" },
      { name: "Hampton", slug: "hampton-va-us" },
      { name: "Harrisonburg", slug: "harrisonburg-va-us" },
      { name: "Hillsville", slug: "hillsville-va-us" },
      { name: "Lebanon", slug: "lebanon-va-us" },
      { name: "Leesburg", slug: "leesburg-va-us" },
      { name: "Luray", slug: "luray-va-us" },
      { name: "Lynchburg", slug: "lynchburg-va-us" },
      { name: "Manassas", slug: "manassas-va-us" },
      { name: "Marion", slug: "marion-va-us" },
      { name: "Marshall", slug: "marshall-va-us" },
      { name: "McLean", slug: "mclean-va-us" },
      { name: "Middleburg", slug: "middleburg-va-us" },
      { name: "Midlothian", slug: "midlothian-va-us" },
      { name: "Moseley", slug: "moseley-va-us" },
      { name: "Mount Vernon", slug: "mount-vernon-va-us" },
      { name: "Newport News", slug: "newport-news-va-us" },
      { name: "Norfolk", slug: "norfolk-va-us" },
      { name: "Petersburg", slug: "petersburg-va-us" },
      { name: "Portsmouth", slug: "portsmouth-va-us" },
      { name: "Prince George", slug: "prince-george-va-us" },
      { name: "Radford", slug: "radford-va-us" },
      { name: "Reston", slug: "reston-va-us" },
      { name: "Richmond", slug: "richmond-va-us" },
      { name: "Roanoke", slug: "roanoke-va-us" },
      { name: "Rocky Mount", slug: "rocky-mount-va-us" },
      { name: "Salem", slug: "salem-va-us" },
      { name: "Smithfield", slug: "smithfield-va-us" },
      { name: "South Boston", slug: "south-boston-va-us" },
      { name: "South Hill", slug: "south-hill-va-us" },
      { name: "Springfield", slug: "springfield-va-us" },
      { name: "Stafford", slug: "stafford-va-us" },
      { name: "Sterling", slug: "sterling-va-us" },
      { name: "Suffolk", slug: "suffolk-va-us" },
      { name: "Vienna", slug: "vienna-va-us" },
      { name: "Virginia Beach", slug: "virginia-beach-va-us" },
      { name: "Warrenton", slug: "warrenton-va-us" },
      { name: "Waynesboro", slug: "waynesboro-va-us" },
      { name: "Williamsburg", slug: "williamsburg-va-us" },
      { name: "Winchester", slug: "winchester-va-us" },
      { name: "Woodbridge", slug: "woodbridge-va-us" },
      { name: "Wytheville", slug: "wytheville-va-us" },
      { name: "Yorktown", slug: "yorktown-va-us" },
    ],
    name: "Virginia",
  },
  {
    locations: [
      { name: "Aberdeen", slug: "aberdeen-wa-us" },
      { name: "Airway Heights", slug: "airway-heights-wa-us" },
      { name: "Allyn-Grapeview", slug: "allyn-grapeview-wa-us" },
      { name: "Anacortes", slug: "anacortes-wa-us" },
      { name: "Arlington", slug: "arlington-wa-us" },
      { name: "Auburn", slug: "auburn-wa-us" },
      { name: "Bainbridge Island", slug: "bainbridge-island-wa-us" },
      { name: "Battle Ground", slug: "battle-ground-wa-us" },
      { name: "Belfair", slug: "belfair-wa-us" },
      { name: "Bellevue", slug: "bellevue-wa-us" },
      { name: "Bellingham", slug: "bellingham-wa-us" },
      { name: "Blaine", slug: "blaine-wa-us" },
      { name: "Bothell", slug: "bothell-wa-us" },
      { name: "Bremerton", slug: "bremerton-wa-us" },
      { name: "Brewster", slug: "brewster-wa-us" },
      { name: "Buckley", slug: "buckley-wa-us" },
      { name: "Burien", slug: "burien-wa-us" },
      { name: "Burlington", slug: "burlington-wa-us" },
      { name: "Camano Island", slug: "camano-island-wa-us" },
      { name: "Carson", slug: "carson-wa-us" },
      { name: "Cashmere", slug: "cashmere-wa-us" },
      { name: "Castle Rock", slug: "castle-rock-wa-us" },
      { name: "Cathlamet", slug: "cathlamet-wa-us" },
      { name: "Chehalis", slug: "chehalis-wa-us" },
      { name: "Cheney", slug: "cheney-wa-us" },
      { name: "Chewelah", slug: "chewelah-wa-us" },
      { name: "Chimacum", slug: "chimacum-wa-us" },
      { name: "Clarkston", slug: "clarkston-wa-us" },
      { name: "Clayton", slug: "clayton-wa-us" },
      { name: "Cle Elum", slug: "cle-elum-wa-us" },
      { name: "Colville", slug: "colville-wa-us" },
      { name: "Cook", slug: "cook-wa-us" },
      { name: "Covington", slug: "covington-wa-us" },
      { name: "Custer", slug: "custer-wa-us" },
      { name: "Davenport", slug: "davenport-wa-us" },
      { name: "Dayton", slug: "dayton-wa-us" },
      { name: "Deming", slug: "deming-wa-us" },
      { name: "Des Moines", slug: "des-moines-wa-us" },
      { name: "East Wenatchee", slug: "east-wenatchee-wa-us" },
      { name: "Edmonds", slug: "edmonds-wa-us" },
      { name: "Ellensburg", slug: "ellensburg-wa-us" },
      { name: "Elma", slug: "elma-wa-us" },
      { name: "Ephrata", slug: "ephrata-wa-us" },
      { name: "Everett", slug: "everett-wa-us" },
      { name: "Everson", slug: "everson-wa-us" },
      { name: "Ferndale", slug: "ferndale-wa-us" },
      { name: "Fife", slug: "fife-wa-us" },
      { name: "Forks", slug: "forks-wa-us" },
      { name: "Freeland", slug: "freeland-wa-us" },
      { name: "Friday Harbor", slug: "friday-harbor-wa-us" },
      { name: "George", slug: "george-wa-us" },
      { name: "Gig Harbor", slug: "gig-harbor-wa-us" },
      { name: "Gold Bar", slug: "gold-bar-wa-us" },
      { name: "Goldendale", slug: "goldendale-wa-us" },
      { name: "Grand Coulee", slug: "grand-coulee-wa-us" },
      { name: "Granite Falls", slug: "granite-falls-wa-us" },
      { name: "Greenbank", slug: "greenbank-wa-us" },
      { name: "Hoquiam", slug: "hoquiam-wa-us" },
      { name: "Ilwaco", slug: "ilwaco-wa-us" },
      { name: "Ione", slug: "ione-wa-us" },
      { name: "Issaquah", slug: "issaquah-wa-us" },
      { name: "Kelso", slug: "kelso-wa-us" },
      { name: "Kenmore", slug: "kenmore-wa-us" },
      { name: "Kennewick", slug: "kennewick-wa-us" },
      { name: "Kettle Falls", slug: "kettle-falls-wa-us" },
      { name: "Kingston", slug: "kingston-wa-us" },
      { name: "Kirkland", slug: "kirkland-wa-us" },
      { name: "Lacey", slug: "lacey-wa-us" },
      { name: "Lake Forest Park", slug: "lake-forest-park-wa-us" },
      { name: "Lake Stevens", slug: "lake-stevens-wa-us" },
      { name: "Longview", slug: "longview-wa-us" },
      { name: "Loon Lake", slug: "loon-lake-wa-us" },
      { name: "Lyle", slug: "lyle-wa-us" },
      { name: "Lynden", slug: "lynden-wa-us" },
      { name: "Lynnwood", slug: "lynnwood-wa-us" },
      { name: "Maple Valley", slug: "maple-valley-wa-us" },
      { name: "Marysville", slug: "marysville-wa-us" },
      { name: "Montesano", slug: "montesano-wa-us" },
      { name: "Moses Lake", slug: "moses-lake-wa-us" },
      { name: "Mount Vernon", slug: "mount-vernon-wa-us" },
      { name: "Mountlake Terrace", slug: "mountlake-terrace-wa-us" },
      { name: "Mukilteo", slug: "mukilteo-wa-us" },
      { name: "Oak Harbor", slug: "oak-harbor-wa-us" },
      { name: "Ocean Shores", slug: "ocean-shores-wa-us" },
      { name: "Okanogan", slug: "okanogan-wa-us" },
      { name: "Olympia", slug: "olympia-wa-us" },
      { name: "Omak", slug: "omak-wa-us" },
      {
        name: "Otis Orchards-East Farms",
        slug: "otis-orchards-east-farms-wa-us",
      },
      { name: "Parkland", slug: "parkland-wa-us" },
      { name: "Peshastin", slug: "peshastin-wa-us" },
      { name: "Port Angeles", slug: "port-angeles-wa-us" },
      {
        name: "Port Hadlock-Irondale",
        slug: "port-hadlock-irondale-wa-us",
      },
      { name: "Port Orchard", slug: "port-orchard-wa-us" },
      { name: "Port Townsend", slug: "port-townsend-wa-us" },
      { name: "Poulsbo", slug: "poulsbo-wa-us" },
      { name: "Prosser", slug: "prosser-wa-us" },
      { name: "Pullman", slug: "pullman-wa-us" },
      { name: "Puyallup", slug: "puyallup-wa-us" },
      { name: "Quincy", slug: "quincy-wa-us" },
      { name: "Redmond", slug: "redmond-wa-us" },
      { name: "Renton", slug: "renton-wa-us" },
      { name: "Ridgefield", slug: "ridgefield-wa-us" },
      { name: "Ritzville", slug: "ritzville-wa-us" },
      { name: "Rochester", slug: "rochester-wa-us" },
      { name: "Seattle", slug: "seattle-wa-us" },
      { name: "Seaview", slug: "seaview-wa-us" },
      { name: "Sedro-Woolley", slug: "sedro-woolley-wa-us" },
      { name: "Sequim", slug: "sequim-wa-us" },
      { name: "Shelton", slug: "shelton-wa-us" },
      { name: "Shoreline", slug: "shoreline-wa-us" },
      { name: "Silverdale", slug: "silverdale-wa-us" },
      { name: "Snohomish", slug: "snohomish-wa-us" },
      { name: "Soap Lake", slug: "soap-lake-wa-us" },
      { name: "South Bend", slug: "south-bend-wa-us" },
      { name: "Spanaway", slug: "spanaway-wa-us" },
      { name: "Spokane", slug: "spokane-wa-us" },
      { name: "Spokane Valley", slug: "spokane-valley-wa-us" },
      { name: "Sprague", slug: "sprague-wa-us" },
      { name: "Stanwood", slug: "stanwood-wa-us" },
      { name: "Stevenson", slug: "stevenson-wa-us" },
      { name: "Tacoma", slug: "tacoma-wa-us" },
      { name: "Tenino", slug: "tenino-wa-us" },
      { name: "Tonasket", slug: "tonasket-wa-us" },
      { name: "Tumwater", slug: "tumwater-wa-us" },
      { name: "Union Gap", slug: "union-gap-wa-us" },
      { name: "Valley", slug: "valley-wa-us" },
      { name: "Vancouver", slug: "vancouver-wa-us" },
      { name: "Vashon", slug: "vashon-wa-us" },
      { name: "Walla Walla", slug: "walla-walla-wa-us" },
      { name: "Wenatchee", slug: "wenatchee-wa-us" },
      { name: "Winthrop", slug: "winthrop-wa-us" },
      { name: "Woodinville", slug: "woodinville-wa-us" },
      { name: "Yakima", slug: "yakima-wa-us" },
      { name: "Yelm", slug: "yelm-wa-us" },
    ],
    name: "Washington",
  },
  {
    locations: [{ name: "Fort Ashby", slug: "fort-ashby-wv-us" }],
    name: "West Virginia",
  },
];

export const CALocations = [
  {
    locations: [
      { name: "Brooks", slug: "brooks-ab-ca" },
      { name: "Calgary", slug: "calgary-ab-ca" },
      { name: "Canmore", slug: "canmore-ab-ca" },
      { name: "Cold Lake", slug: "cold-lake-ab-ca" },
      { name: "Devon", slug: "devon-ab-ca" },
      { name: "Edmonton", slug: "edmonton-ab-ca" },
      { name: "Fort Saskatchewan", slug: "fort-saskatchewan-ab-ca" },
      { name: "Grande Prairie", slug: "grande-prairie-ab-ca" },
      { name: "Grimshaw", slug: "grimshaw-ab-ca" },
      { name: "High River", slug: "high-river-ab-ca" },
      { name: "Hinton", slug: "hinton-ab-ca" },
      { name: "Lethbridge", slug: "lethbridge-ab-ca" },
      { name: "Lloydminster", slug: "lloydminster-ab-ca" },
      { name: "Medicine Hat", slug: "medicine-hat-ab-ca" },
      { name: "Nisku", slug: "nisku-ab-ca" },
      { name: "Peace River", slug: "peace-river-ab-ca" },
      { name: "Red Deer", slug: "red-deer-ab-ca" },
      { name: "Sherwood Park", slug: "sherwood-park-ab-ca" },
      { name: "Spruce Grove", slug: "spruce-grove-ab-ca" },
      { name: "St. Albert", slug: "st-albert-ab-ca" },
      { name: "Stettler", slug: "stettler-ab-ca" },
      { name: "Stony Plain", slug: "stony-plain-ab-ca" },
      { name: "Strathmore", slug: "strathmore-ab-ca" },
      { name: "Whitecourt", slug: "whitecourt-ab-ca" },
    ],
    name: "Alberta",
  },
  {
    locations: [
      { name: "Athalmer", slug: "athalmer-bc-ca" },
      { name: "Canoe", slug: "canoe-bc-ca" },
      { name: "Castlegar", slug: "castlegar-bc-ca" },
      { name: "Dawson Creek", slug: "dawson-creek-bc-ca" },
      { name: "Kamloops", slug: "kamloops-bc-ca" },
      { name: "Kimberley", slug: "kimberley-bc-ca" },
      { name: "Nelson", slug: "nelson-bc-ca" },
      { name: "Port Hardy", slug: "port-hardy-bc-ca" },
      { name: "Pouce Coupe", slug: "pouce-coupe-bc-ca" },
      { name: "Trail", slug: "trail-bc-ca" },
      { name: "Tumbler Ridge", slug: "tumbler-ridge-bc-ca" },
      { name: "Vancouver", slug: "vancouver-bc-ca" },
      { name: "Victoria", slug: "victoria-bc-ca" },
    ],
    name: "British Columbia",
  },
  {
    locations: [
      { name: "Brandon", slug: "brandon-mb-ca" },
      { name: "Dauphin", slug: "dauphin-mb-ca" },
      { name: "Morden", slug: "morden-mb-ca" },
      { name: "Southport", slug: "southport-mb-ca" },
      { name: "Thompson", slug: "thompson-mb-ca" },
      { name: "Winnipeg", slug: "winnipeg-mb-ca" },
    ],
    name: "Manitoba",
  },
  {
    locations: [
      { name: "Bathurst", slug: "bathurst-nb-ca" },
      { name: "Campbellton", slug: "campbellton-nb-ca" },
      { name: "Dieppe", slug: "dieppe-nb-ca" },
      { name: "Edmundston", slug: "edmundston-nb-ca" },
      { name: "Fredericton", slug: "fredericton-nb-ca" },
      { name: "Miramichi", slug: "miramichi-nb-ca" },
      { name: "Moncton", slug: "moncton-nb-ca" },
      { name: "Old Ridge", slug: "old-ridge-nb-ca" },
      { name: "Oromocto", slug: "oromocto-nb-ca" },
      { name: "Perth-Andover", slug: "perth-andover-nb-ca" },
      { name: "Richibucto", slug: "richibucto-nb-ca" },
      { name: "Rothesay", slug: "rothesay-nb-ca" },
      { name: "Sackville", slug: "sackville-nb-ca" },
      { name: "Saint John", slug: "saint-john-nb-ca" },
      { name: "Shediac", slug: "shediac-nb-ca" },
      { name: "Sussex", slug: "sussex-nb-ca" },
      { name: "Tracadie-Sheila", slug: "tracadie-sheila-nb-ca" },
    ],
    name: "New Brunswick",
  },
  {
    locations: [
      { name: "Carbonear", slug: "carbonear-nl-ca" },
      { name: "Clarenville", slug: "clarenville-nl-ca" },
      { name: "Coley's Point South", slug: "coley's-point-south-nl-ca" },
      {
        name: "Conception Bay South",
        slug: "conception-bay-south-nl-ca",
      },
      { name: "Corner Brook", slug: "corner-brook-nl-ca" },
      { name: "Deer Lake", slug: "deer-lake-nl-ca" },
      { name: "Gander", slug: "gander-nl-ca" },
      { name: "Grand Falls-Windsor", slug: "grand-falls-windsor-nl-ca" },
      { name: "Holyrood", slug: "holyrood-nl-ca" },
      { name: "Labrador City", slug: "labrador-city-nl-ca" },
      { name: "Mount Pearl", slug: "mount-pearl-nl-ca" },
      { name: "Paradise", slug: "paradise-nl-ca" },
      {
        name: "Portugal Cove-St. Philip's",
        slug: "portugal-cove-st-philip's-nl-ca",
      },
      { name: "St. John's", slug: "st-johns-nl-ca" },
      { name: "Stephenville", slug: "stephenville-nl-ca" },
    ],
    name: "Newfoundland And Labrador",
  },
  {
    locations: [
      { name: "Amherst", slug: "amherst-ns-ca" },
      { name: "Antigonish", slug: "antigonish-ns-ca" },
      { name: "Bridgewater", slug: "bridgewater-ns-ca" },
      { name: "Dartmouth", slug: "dartmouth-ns-ca" },
      { name: "Halifax", slug: "halifax-ns-ca" },
      { name: "Lower Sackville", slug: "lower-sackville-ns-ca" },
      { name: "New Glasgow", slug: "new-glasgow-ns-ca" },
      { name: "New Minas", slug: "new-minas-ns-ca" },
      { name: "Sydney", slug: "sydney-ns-ca" },
      { name: "Truro", slug: "truro-ns-ca" },
      { name: "Yarmouth", slug: "yarmouth-ns-ca" },
    ],
    name: "Nova Scotia",
  },
  {
    locations: [
      { name: "Fort Simpson", slug: "fort-simpson-nt-ca" },
      { name: "Fort Smith", slug: "fort-smith-nt-ca" },
      { name: "Hay River", slug: "hay-river-nt-ca" },
      { name: "Norman Wells", slug: "norman-wells-nt-ca" },
      { name: "Yellowknife", slug: "yellowknife-nt-ca" },
    ],
    name: "Northwest Territories",
  },
  {
    locations: [{ name: "Iqaluit", slug: "iqaluit-nu-ca" }],
    name: "Nunavut",
  },
  {
    locations: [
      { name: "Ajax", slug: "ajax-on-ca" },
      { name: "Brampton", slug: "brampton-on-ca" },
      { name: "Burlington", slug: "burlington-on-ca" },
      { name: "Hamilton", slug: "hamilton-on-ca" },
      { name: "Kingston", slug: "kingston-on-ca" },
      { name: "London", slug: "london-on-ca" },
      { name: "Niagara Falls", slug: "niagara-falls-on-ca" },
      { name: "Oshawa", slug: "oshawa-on-ca" },
      { name: "Ottawa", slug: "ottawa-on-ca" },
      { name: "St. Catharines", slug: "st-catharines-on-ca" },
      { name: "Sudbury", slug: "sudbury-on-ca" },
      { name: "Toronto", slug: "toronto-on-ca" },
    ],
    name: "Ontario",
  },
  {
    locations: [
      { name: "Charlottetown", slug: "charlottetown-pe-ca" },
      { name: "Montague", slug: "montague-pe-ca" },
      { name: "O'Leary", slug: "o'leary-pe-ca" },
      { name: "Summerside", slug: "summerside-pe-ca" },
    ],
    name: "Prince Edward Island",
  },
  {
    locations: [
      { name: "Drummondville", slug: "drummondville-qc-ca" },
      { name: "Lévis", slug: "l%C3%A9vis-qc-ca" },
      { name: "Mascouche", slug: "mascouche-qc-ca" },
      { name: "Mirabel", slug: "mirabel-qc-ca" },
      { name: "Montréal", slug: "montr%C3%A9al-qc-ca" },
      { name: "Québec", slug: "qu%C3%A9bec-qc-ca" },
      { name: "Rimouski", slug: "rimouski-qc-ca" },
      {
        name: "Saint-Jean-Sur-Richelieu",
        slug: "saint-jean-sur-richelieu-qc-ca",
      },
      { name: "Trois-Rivières", slug: "trois-rivi%C3%A8res-qc-ca" },
    ],
    name: "Quebec City",
  },
  {
    locations: [
      { name: "Battleford", slug: "battleford-sk-ca" },
      { name: "Esterhazy", slug: "esterhazy-sk-ca" },
      { name: "Estevan", slug: "estevan-sk-ca" },
      { name: "Martensville", slug: "martensville-sk-ca" },
      { name: "Moose Jaw", slug: "moose-jaw-sk-ca" },
      { name: "Moosomin", slug: "moosomin-sk-ca" },
      { name: "North Battleford", slug: "north-battleford-sk-ca" },
      { name: "Pilot Butte", slug: "pilot-butte-sk-ca" },
      { name: "Prince Albert", slug: "prince-albert-sk-ca" },
      { name: "Regina", slug: "regina-sk-ca" },
      { name: "Saskatoon", slug: "saskatoon-sk-ca" },
      { name: "Swift Current", slug: "swift-current-sk-ca" },
      { name: "Warman", slug: "warman-sk-ca" },
      { name: "Yorkton", slug: "yorkton-sk-ca" },
    ],
    name: "Saskatchewan",
  },
  {
    locations: [{ name: "Whitehorse", slug: "whitehorse-yt-ca" }],
    name: "Yukon",
  },
];
